import UIFetchService from '../Service/UIFetchService';
import { ODPSLexer, ODPSParser } from '../Service/ODPSParser';
import ODPSAnalyzer from '../Service/ODPSAnalyzer';
import { dateTimeFormat, ifEmpty, isEmpty, isNotEmpty, parseUrlSearch } from '../Service/Utils'
import copy from 'copy-to-clipboard';
import { Prompt } from "react-router-dom";
import { format } from 'sql-formatter';

import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { registerLanguageDictionary, zhCN } from 'handsontable/i18n';
import { HotTable } from '@handsontable/react';
import Handsontable from 'handsontable';

import { Base64 } from 'js-base64';

import React from 'react';
import {
    Layout, Row, Col, Tree, Input, Button, Space, Switch, Radio, Tooltip, Tabs, Pagination, Modal, Table, Menu,
    Dropdown, message, notification, Checkbox, TimePicker, Divider, Select, Tag
} from 'antd';
import {
    PauseCircleOutlined, AppstoreOutlined, TableOutlined, LoadingOutlined, CloseOutlined, DollarOutlined,
    FileTextOutlined, CheckCircleTwoTone, RedoOutlined, FolderOutlined, CaretRightOutlined, SaveOutlined,
    DownOutlined, PauseOutlined, DeleteOutlined, ExclamationCircleOutlined, HomeOutlined, PlusOutlined, SettingOutlined,
    EditOutlined, CodeOutlined, BugOutlined, MinusOutlined, CopyOutlined, QuestionCircleOutlined, ArrowUpOutlined, ArrowDownOutlined,
    CheckCircleOutlined, CloseCircleOutlined, FormOutlined
} from '@ant-design/icons';

import Icon from '@ant-design/icons';
import EditTaskModal from './EditTaskModal';
import HistoryView from './HistoryView';

//import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/default-highlight';
const { SubMenu } = Menu;

const maxComputeSvg = () => (
    <svg t="1638351378507" className="icon" viewBox="0 0 1024 1024" version="1.1" p-id="1642" width="1em" height="1em"><defs><style type="text/css"></style></defs><path d="M576.0144 0a128 128 0 0 1 108.048 196.672L866.0944 451.52a128 128 0 1 1-78.128 55.824L605.9024 252.48c-2.688 0.64-5.44 1.216-8.192 1.68l-102.368 470.88A159.936 159.936 0 0 1 576.0144 864c0 88.368-71.632 160-160 160s-160-71.632-160-160c0-40.752 15.232-77.936 40.32-106.192l-148.416-247.36a128 128 0 1 1 82.32-49.408l148.384 247.36c7.44-1.792 15.088-3.04 22.88-3.76l102.384-470.88A128 128 0 0 1 576.0144 0z" fill="#0078FF" p-id="1643"></path></svg>
);
const MaxComputeIcon = props => <Icon component={maxComputeSvg} {...props} />;

const hologresSvg = () => (
    <svg t="1638351675322" className="icon" viewBox="0 0 1024 1024" version="1.1" p-id="645" width="1em" height="1em"><defs><style type="text/css"></style></defs><path d="M812.906667 783.893333l12.202666 1.664c95.274667 13.610667 132.778667 33.706667 147.413334 48.490667 7.786667 7.850667 8.789333 13.994667 8.789333 18.474667 0 27.456-37.504 48.704-111.381333 63.104l-9.386667 1.770666c-73.237333 13.226667-179.2 19.946667-333.888 21.269334v-168.96l24.234667 0.064c108.714667 0.704 194.688 5.333333 262.016 14.122666z m-594.197334 0v146.816l-3.690666-0.576c-59.093333-10.24-135.829333-29.674667-164.224-59.84-6.848-7.253333-8.042667-12.522667-8.128-16l0.042666-1.706666 0.085334-0.768c0.426667-3.690667 2.346667-9.024 8.106666-15.253334l2.709334-2.730666c12.266667-11.029333 32.170667-19.370667 45.930666-24.234667 29.397333-10.410667 68.928-18.816 118.016-25.173333l1.152-0.533334zM42.666667 302.336c3.456 1.877333 6.976 3.626667 10.538666 5.312l6.805334 3.072c5.994667 2.624 12.096 5.034667 18.261333 7.232 37.376 13.333333 78.848 24.149333 140.437333 31.296v326.869333c-61.205333 7.04-102.357333 16.277333-139.498666 29.397334a373.056 373.056 0 0 0-18.624 7.317333l-5.504 2.453333-4.608 2.154667-3.605334 1.813333-4.202666 2.197334V302.336z m938.666666 0.938667v416.341333l-3.456-1.813333-3.882666-1.898667a256.853333 256.853333 0 0 0-6.912-3.157333l-1.173334-0.597334-8.384-3.498666-3.84-1.493334-8.085333-2.986666-5.44-1.856-3.989333-1.322667-6.016-1.877333c-2.773333-0.853333-5.568-1.706667-8.362667-2.496l-1.685333-0.426667a344.405333 344.405333 0 0 0-9.813334-2.688l-4.309333-1.066667-7.402667-1.770666-8.64-1.962667-10.325333-2.133333-5.056-1.002667-7.125333-1.365333-13.269334-2.346667-10.794666-1.685333-9.6-1.408-4.330667-0.64-13.653333-1.792-1.386667-0.213334-7.978667-0.981333-9.472-1.066667-9.28-1.002666c-47.296-4.906667-101.866667-8.170667-164.266666-9.770667l-13.376-0.298667-24.426667-0.426666-18.56-0.256-16.917333-0.128-23.466667-0.085334v-300.373333l23.552-0.106667c134.826667-1.109333 237.653333-8.32 313.173333-21.909333l16.213334-3.050667 4.992-0.981333 0.704-0.170667 9.002666-1.92 10.24-2.325333 7.146667-1.792 7.850667-2.112 7.616-2.197333 7.68-2.346667c5.141333-1.642667 10.24-3.413333 15.274666-5.333333l0.213334-0.128c2.56-0.981333 5.141333-1.984 7.68-3.050667l0.234666-0.064 3.84-1.642667 4.330667-1.92 3.456-1.6 4.330667-2.069333 3.328-1.706667 3.818666-2.026666z m-659.989333 364.16V356.522667h-0.490667c21.76 1.322667 56.192 2.773333 103.274667 4.266666l-0.149333 302.378667c-38.08 0.896-70.186667 2.325333-102.613334 4.309333zM870.101333 108.672l10.730667 2.218667C929.002667 121.258667 981.333333 139.584 981.333333 170.24c0 23.445333-43.178667 45.866667-115.946666 60.437333l-7.125334 1.408c-76.458667 14.378667-185.962667 21.610667-331.605333 22.058667V85.333333l31.274667 0.362667c143.061333 2.090667 243.498667 9.536 312.170666 22.954667zM220.202667 94.08v146.624c-52.48-6.506667-86.336-15.253333-114.986667-24.597333l-5.930667-2.090667-6.912-2.56c-16.512-6.357333-37.738667-16.725333-46.08-29.845333l-0.597333-0.896-0.512-0.96a22.506667 22.506667 0 0 1-1.92-4.949334A21.184 21.184 0 0 1 42.666667 170.218667c0-8.384 10.026667-19.072 27.541333-29.397334 20.309333-11.946667 49.408-22.805333 86.485333-32.405333 22.869333-5.76 40.277333-10.389333 63.509334-14.357333z" fill="#FF6A00" p-id="646"></path></svg>
)
const HologresIcon = props => <Icon component={hologresSvg} {...props} />;

// const schemaSvg = () => (
//     <svg t="1638523654777" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2934" width="1em" height="1em"><path d="M1024 240C1024 107.5 794.8 0 512 0S0 107.5 0 240v176h0.1c-0.1 1.8-0.1 3.5-0.1 5.3 0 3.6 0.2 7.1 0.5 10.7H0v170.7c0 1.8 0 3.6 0.1 5.3H0v176c0 132.5 229.2 240 512 240s512-107.5 512-240V608h-0.1c0.1-1.8 0.1-3.5 0.1-5.3V432h-0.5c0.3-3.5 0.5-7.1 0.5-10.7 0-1.8 0-3.6-0.1-5.3h0.1V240z m-64 544c0 16.1-8 33.1-23.8 50.5-19.8 21.9-50.7 43.1-89.4 61.2-42.3 19.8-92.1 35.5-148 46.6C639.8 954.1 577 960 512 960s-127.8-5.9-186.8-17.6c-55.9-11.1-105.7-26.8-148-46.6-38.7-18.2-69.6-39.3-89.4-61.2C72 817.1 64 800.1 64 784v-65.1c6.8 5.7 14.1 11.3 21.8 16.8 91.8 64.5 248.4 107 426.2 107s334.4-42.5 426.2-107c1.1-0.8 2.3-1.6 3.4-2.4 0.1-0.1 0.2-0.2 0.4-0.3 1-0.7 1.9-1.4 2.9-2.1 0.8-0.6 1.7-1.2 2.5-1.9 0.7-0.5 1.3-1 2-1.5 3.7-2.8 7.2-5.7 10.6-8.6V784z m0-181.3c0 15.4-7.3 31.6-21.8 48.3-0.6 0.7-1.3 1.5-2 2.2-12.5 13.9-29.5 27.4-50.1 40.1-11.9 7.4-25.1 14.4-39.3 21.1-42.3 19.8-92.1 35.5-148 46.6-59 11.7-121.9 17.6-186.8 17.6s-127.8-5.9-186.8-17.6c-55.9-11.1-105.7-26.8-148-46.6-14.2-6.7-27.3-13.7-39.3-21.1-20.6-12.7-37.6-26.3-50.1-40.1-0.7-0.7-1.3-1.5-2-2.2C71.3 634.3 64 618.1 64 602.7v-65.1c6.8 5.7 14.1 11.3 21.8 16.8 91.8 64.5 248.4 107 426.2 107s334.4-42.5 426.2-107c7.7-5.4 15-11 21.8-16.8v65.1z m0-181.4c0 15.4-7.3 31.6-21.8 48.3-0.6 0.7-1.3 1.5-2 2.2-12.5 13.9-29.5 27.4-50.1 40.1-11.9 7.4-25.1 14.4-39.3 21.1-42.3 19.8-92.1 35.5-148 46.6-59 11.7-121.9 17.6-186.8 17.6s-127.8-5.9-186.8-17.6c-55.9-11.1-105.7-26.8-148-46.6-14.2-6.7-27.4-13.7-39.3-21.1-20.6-12.7-37.6-26.3-50.1-40.1-0.7-0.7-1.3-1.5-2-2.2C71.3 453 64 436.7 64 421.3v-65.1c6.8 5.7 14.1 11.3 21.8 16.8 91.8 64.5 248.4 107 426.2 107s334.4-42.5 426.2-107c7.7-5.4 15-11 21.8-16.8v65.1z m-21.8-133c-0.6 0.7-1.3 1.5-2 2.2-12.5 13.9-29.5 27.4-50.1 40.1-11.9 7.4-25.1 14.4-39.3 21.1-42.3 19.8-92.1 35.5-148 46.6C639.8 410.1 577 416 512 416s-127.8-5.9-186.8-17.6c-55.9-11.1-105.7-26.8-148-46.6-14.2-6.7-27.3-13.7-39.3-21.1-20.6-12.7-37.6-26.3-50.1-40.1-0.7-0.7-1.3-1.5-2-2.2C71.3 271.6 64 255.4 64 240c0-16.1 8-33.1 23.8-50.5 19.8-21.9 50.7-43.1 89.4-61.2 42.3-19.8 92.1-35.5 148-46.6C384.2 69.9 447 64 512 64s127.8 5.9 186.8 17.6c55.9 11.1 105.7 26.8 148 46.6 38.7 18.2 69.6 39.3 89.4 61.2C952 206.9 960 223.9 960 240c0 15.4-7.3 31.6-21.8 48.3z" p-id="2935" fill="#389e0d"></path></svg>
// )
//const SchemaIcon = props => <Icon component={schemaSvg} {...props} />;

const fontSizeOpts = [
    { label: '大', value: 20 },
    { label: '中', value: 15 },
    { label: '小', value: 12 },
];

const odpsCompletionItemProvider = {
    resolveCompletionItem: () => null,
    provideCompletionItems: () => {
        return { suggestions: [] };
    },
    triggerCharacters: ['.']
};
monaco.languages.registerCompletionItemProvider('sql', odpsCompletionItemProvider);

const odpsHoverProvider = {
    provideHover: () => {
        return { contents: [] };
    }
};
monaco.languages.registerHoverProvider('sql', odpsHoverProvider);

registerLanguageDictionary(zhCN);

class QueryingWorksView extends React.Component {
    static sequenceNumber = 0;
    static schemasCacheKey = 'queryWorks.schemas.cache';
    static currentCacheFusesKey = 'queryWorks.schemas.cache.fuses';
    static currentCacheFuses = 1;

    constructor() {
        super();

        const fontSize = localStorage.getItem('sql.fontSize');
        const theme = localStorage.getItem('sql.theme');
        const bottomSiderY = localStorage.getItem('sql.bottomSiderY');
        const showCurrentResultOnly = localStorage.getItem('sql.showCurrentResultOnly') === 'true';
        const cacheFuses = localStorage.getItem(QueryingWorksView.currentCacheFusesKey);
        this.cacheFuses = isEmpty(cacheFuses) ? 0 : Number.parseInt(cacheFuses);
        this.bottomSiderY = bottomSiderY === null ? document.body.clientHeight - 540 : Number.parseInt(bottomSiderY);
        this.spawnIndex = 0;
        this.contentDirty = false;
        this.editors = {};
        this.schemaDirs = {};
        this.state = {
            windowHeight: document.body.clientHeight,
            fontSize: fontSize === null ? 15 : parseInt(fontSize),
            theme: theme === null ? 'vs-dark' : theme,
            files: [],
            schemasTree: [],
            extendedKeys: [],
            clientWidth: document.body.clientWidth,
            clientHeight: document.body.clientHeight,
            schemaKey: '',
            schemaKeywords: [],
            devScriptsTree: [],
            tabsActiveKey: 'history',
            task: {},
            taskCost: [],
            preTaskError: 'OK',
            results: {},
            history: [],
            historyPageNo: 1,
            historyPageSize: 20,
            leftSiderContextNode: undefined,
            leftSiderSelectedNode: undefined,
            bottomSiderAdjusting: false,
            confirmFileNameVisible: false,
            bottomSiderY: this.bottomSiderY,
            showCurrentResultOnly,
            projects: [],
            activeProject: '',
            activeDataOrigin: '',
            addFileContext: null,
            contentDirty: false,
            dataDevEditor: {
                visible: false,
                addOrUpdate: true
            },
            tableSchemaModal: {
                visible: false,
            },
            confirmInputModal: {
                visible: false,
                value: '',
                title: '',
            },
            hint: false,
            devTaskPending: [], // { taskId: number, scriptId: number, timer: number }
            // 展示左侧树开发脚本错误信息
            treeDevScriptErrorVisible: false,
            currentDevJobs: [],
            generateDDLModal: {
                visible: false,
                ddl: '',
            }
        };
    }

    async componentDidMount() {
        this.fs = await this.requestFs();
        if (this.cacheFuses < QueryingWorksView.currentCacheFuses) {
            console.log(`invalidateCache, clause: ${this.cacheFuses} < ${QueryingWorksView.currentCacheFuses}`);
            await this.invalidateCache();
            localStorage.setItem(QueryingWorksView.currentCacheFusesKey, QueryingWorksView.currentCacheFuses.toString());
        }

        odpsCompletionItemProvider.provideCompletionItems = this.provideCompletionItems;
        odpsHoverProvider.provideHover = this.provideHover;

        window.onresize = this.onWindowSize;
        this.contentSavingTimer = setInterval(() => {
            let dirty = 0;
            Object.keys(this.editors).forEach(domId => {
                const ed = this.editors[domId];
                if (ed.key > 0 && ed.contentDirty) {
                    this.saveFile(ed.key.toString());
                }
                if (ed.contentDirty) {
                    dirty++;
                }
            });
            if (dirty > 0) {
                this.saveTags(this.state.files);
            }
        }, 15 * 1000);

        this.syntaxCheckingTimer = setInterval(() => {
            const file = this.state.files.find(file => file.id.toString() === this.state.filesActiveKey?.toString());
            if (file) {
                const editor = this.editors[file.domId];
                if (editor && editor.syntaxCheckingDirty) {
                    //this.doSyntaxChecking(editor.instance);
                    editor.syntaxCheckingDirty = false;
                }
            }
        }, 1 * 1000);

        this.fetchOwnedProjects()
        this.fetchOwnedSchemasTree(this.state.schemaKey);
        this.fetchOwnedDevScriptsTree("");

        this.fetchJobsHistory(this.state.historyPageNo, this.state.historyPageSize);
        UIFetchService.get('/api/v1/querying_works/owned/latest_task')
            .then(task => {
                if (typeof task === 'object') {
                    if (task.state !== 'FAIL' && task.state !== 'OK') {
                        this.beginPollTask(task.id);
                        this.setState({ task });
                    }
                }
            })

        document.onmousemove = (e) => {
            if (this.state.bottomSiderAdjusting) {
                this.bottomSiderY = e.clientY - 155;
                this.onWindowSize();
            }
        }

        document.onmouseup = () => {
            if (this.state.bottomSiderAdjusting) {
                this.setState({ bottomSiderAdjusting: false });
                localStorage.setItem('sql.bottomSiderY', this.bottomSiderY);
                //console.log('up');
            }
        }

        const json = localStorage.getItem('sql.currentTags');
        let tags = [];
        if (isNotEmpty(json)) {
            tags = JSON.parse(json);
        }
        for (let tag of tags) {
            if (tag.id > 0) {
                this.openFile(tag.id);
            } else {
                if (isEmpty(tag.origin)) {
                    continue
                }
                this.addFile(tag.fileName, tag.content, tag.origin, tag.projectName);
            }
        }

        const params = parseUrlSearch(window.location.search);
        if (isNotEmpty(params.aid)) {
            const { title, sql, projectName } = await UIFetchService.get(`/api/v1/querying_works/associated_sql/oneshot?aid=${params.aid}`);
            if (isNotEmpty(sql) && isNotEmpty(projectName)) {
                this.addFile(title, sql, 'MaxCompute', projectName);
            }
        }
        window.addEventListener("beforeunload", this.handleWindowBeforeUnload);


        const firstVisit = localStorage.getItem('sql.firstVisit');
        if (isEmpty(firstVisit)) {
            this.setState({ hint: true });
            localStorage.setItem('sql.firstVisit', 'false');
            setTimeout(() => this.setState({ hint: false }), 5000);
        }

        this.onWindowSize();
    }

    componentWillUnmount() {
        Object.keys(this.editors).map(key => this.editors[key].instance.dispose());
        window.onresize = undefined;
        clearInterval(this.contentSavingTimer);
        clearInterval(this.taskPollingTimer);
        clearInterval(this.syntaxCheckingTimer);
        delete document.onmouseup;
        delete document.onmousemove;

        window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);

        odpsCompletionItemProvider.provideCompletionItems = () => {
            return { suggestions: [] };
        };
        odpsHoverProvider.provideHover = () => {
            return { contents: [] };
        };
    }

    handleWindowBeforeUnload = e => {
        e.preventDefault();
        e.returnValue = '是否要离开本页面？';
    }

    onWindowSize = () => {
        if (this.bottomSiderY > document.body.clientHeight - 240) {
            this.bottomSiderY = document.body.clientHeight - 240
        }

        this.setState({
            clientHeight: document.body.clientHeight,
            clientWidth: document.body.clientWidth,
            bottomSiderY: this.bottomSiderY
        });

        if (this.monacoInstance === undefined) {
            return;
        }

        this.monacoInstance.layout({
            width: document.body.clientWidth,
            height: this.bottomSiderY
        });
    }

    findSchemasTreeNode(root, key) {
        for (const node of root) {
            if (node.key === key) {
                return {parent: node.parent, target: node}
            }
            const { parent, target } = this.doFindSchemasTreeNode(node, key);
            if (target !== undefined) {
                return { parent, target };
            }
        }
        return {};
    }

    doFindSchemasTreeNode(root, key) {
        if (root.children !== undefined && root.children !== null) {
            for (const node of root.children) {
                if (node.key === key) {
                    return { parent: root, target: node };
                }
                const { parent, target } = this.doFindSchemasTreeNode(node, key);
                if (target !== undefined) {
                    return { parent, target };
                }
            }
        }
        return {};
    }

    async onMkDir(syntaxAndProjectName, value) {
        if (isEmpty(value)) {
            return;
        }
        const query = `?name=${value}&projectName=${syntaxAndProjectName.projectName}&syntax=${ifEmpty(syntaxAndProjectName.syntax, '')}`
        const rs = await UIFetchService.post(`/api/v1/querying_works/owned/schemas/tree/dirs${query}`);
        if (!rs) {
            return;
        }

        if (syntaxAndProjectName.syntax === 'ODPS-DEV') {
            this.setState(({ devScriptsTree }) => {
                const { target } = this.findSchemasTreeNode(devScriptsTree, this.state.leftSiderContextNode.key);
                const dummyDir = {
                    id: rs.id,
                    name: value,
                    ...syntaxAndProjectName,
                };
                target.children = [{
                    title: value,
                    key: `dir-${rs.id}`,
                    icon: <FolderOutlined style={{ color: '#faad14' }} />,
                    children: [],
                    value: dummyDir
                }, ...target.children];
                const key = `${dummyDir.syntax}/${dummyDir.projectName}`;
                let dirs = this.schemaDirs[key];
                if (dirs === undefined) {
                    dirs = [];
                    this.schemaDirs[key] = dirs;
                }
                dirs.push(dummyDir);
                return { devScriptsTree: [...devScriptsTree] };
            });
        } else {
            this.setState(({ schemasTree }) => {
                const { target } = this.findSchemasTreeNode(schemasTree, this.state.leftSiderContextNode.key);
                const dummyDir = {
                    id: rs.id,
                    name: value,
                    ...syntaxAndProjectName,
                };
                target.children = [{
                    title: value,
                    key: `dir-${rs.id}`,
                    icon: <FolderOutlined style={{ color: '#faad14' }} />,
                    children: [],
                    value: dummyDir
                }, ...target.children];
                const key = `${dummyDir.syntax}/${dummyDir.projectName}`;
                let dirs = this.schemaDirs[key];
                if (dirs === undefined) {
                    dirs = [];
                    this.schemaDirs[key] = dirs;
                }
                dirs.push(dummyDir);
                return { schemasTree: [...schemasTree] };
            });
            await this.invalidateCache();
        }
    }

    async onRenameDir(dirId, newName) {
        await UIFetchService.post(`/api/v1/querying_works/owned/schemas/tree/dirs/${dirId}/rename?newName=${newName}`);
        if (this.state.leftSiderContextNode?.value.syntax === 'ODPS-DEV') {
            const { target } = this.findSchemasTreeNode(this.state.devScriptsTree, `dir-${dirId}`);
            if (target === undefined) {
                return;
            }
            this.setState(({ devScriptsTree }) => {
                target.title = newName;
                target.value.name = newName;
                return { devScriptsTree: [...devScriptsTree] };
            });
        } else {
            const { target } = this.findSchemasTreeNode(this.state.schemasTree, `dir-${dirId}`);
            if (target === undefined) {
                return;
            }
            this.setState(({ schemasTree }) => {
                target.title = newName;
                target.value.name = newName;
                return { schemasTree: [...schemasTree] };
            });
            //this.fetchOwnedSchemasTree(this.state.schemaKey, true);
            await this.invalidateCache();
        }
    }

    async onDeleteDir(dirId) {
        await UIFetchService.delete(`/api/v1/querying_works/owned/schemas/tree/dirs/${dirId}`);
        if (this.state.leftSiderContextNode?.value.syntax === 'ODPS-DEV') {
            const { parent, target } = this.findSchemasTreeNode(this.state.devScriptsTree, `dir-${dirId}`);
            if (target === undefined) {
                return;
            }
            this.setState(({ devScriptsTree }) => {
                parent.children = parent.children.filter(node => node.key !== target.key);
                const key = `${target.value.syntax}/${target.value.projectName}`;
                const dirs = this.schemaDirs[key];
                if (dirs instanceof Array) {
                    this.schemaDirs[key] = dirs.filter(dir => dir.id !== dirId);
                }
                return { devScriptsTree: [...devScriptsTree] };
            });
        } else {
            const { parent, target } = this.findSchemasTreeNode(this.state.schemasTree, `dir-${dirId}`);
            if (target === undefined) {
                return;
            }
            this.setState(({ schemasTree }) => {
                parent.children = parent.children.filter(node => node.key !== target.key);
                const key = `${target.value.syntax}/${target.value.projectName}`;
                const dirs = this.schemaDirs[key];
                if (dirs instanceof Array) {
                    this.schemaDirs[key] = dirs.filter(dir => dir.id !== dirId);
                }
                return { schemasTree: [...schemasTree] };
            });
            await this.invalidateCache();
        }
    }

    async onMoveFileTo(fileId, dirId, scriptId) {
        await UIFetchService.post(`/api/v1/querying_works/owned/schemas/tree/files/${fileId}/to/${dirId}`);
        if (scriptId != null) {
            const old = this.findSchemasTreeNode(this.state.devScriptsTree, `file-${fileId}`);
            if (old.target === undefined) {
                return;
            }
            const { target } = this.findSchemasTreeNode(this.state.devScriptsTree,
                dirId > 0 ? `dir-${dirId}` : `ODPS-dev-scripts`);
            if (target === undefined) {
                return;
            }
            this.setState(({ devScriptsTree }) => {
                old.parent.children = old.parent.children.filter(node => node.key !== old.target.key);
                target.children.push(old.target);
                return { devScriptsTree: [...devScriptsTree] };
            });
        } else {
            const old = this.findSchemasTreeNode(this.state.schemasTree, `file-${fileId}`);
            if (old.target === undefined) {
                return;
            }
            const { target } = this.findSchemasTreeNode(this.state.schemasTree,
                dirId > 0 ? `dir-${dirId}` : `${old.target.value.projectName}-saved-files`);
            if (target === undefined) {
                return;
            }
            this.setState(({ schemasTree }) => {
                old.parent.children = old.parent.children.filter(node => node.key !== old.target.key);
                target.children.push(old.target);
                return { schemasTree: [...schemasTree] };
            });
            //this.fetchOwnedSchemasTree(this.state.schemaKey, true);
            await this.invalidateCache();
        }
    }

    render() {
        const currentFile = this.getCurrentFile();

        const bottomSiderHeight = document.body.clientHeight - this.state.bottomSiderY - 230;
        let leftSiderContextMenu = <></>;
        //console.log('leftSider', this.state.leftSiderContextNode);
        if (this.state.leftSiderContextNode !== undefined && this.state.leftSiderContextNode.key.startsWith('file-')) {
            //console.log(this.state.leftSiderContextNode);
            const { syntax, projectName } = this.state.leftSiderContextNode.value;
            let dirs = this.schemaDirs[`${syntax}/${projectName}`];
            if(this.state.leftSiderContextNode.value.scriptId != null){
                dirs = this.schemaDirs[`ODPS-DEV/${projectName}`];
            }
            if (dirs === undefined) {
                dirs = [];
            }
            leftSiderContextMenu = <Menu onClick={async e => {
                const node = this.state.leftSiderContextNode;
                const id = node.key.substring(5);
                switch (e.key) {
                    case 'delete':
                        this.deleteFile(id, node.value);
                        break;
                    case 'rename':
                        this.showConfirmFileNameModal(node.value.fileName, 'rename', id);
                        break;
                    case 'move-to-root':
                        await this.onMoveFileTo(node.value.id, 0, node.value.scriptId);
                        break
                    default:
                        if (e.key.startsWith('move-to-')) {
                            const dirId = Number.parseInt(e.key.substring(8));
                            await this.onMoveFileTo(node.value.id, dirId, node.value.scriptId);
                        }
                        break;
                }
            }}>
                <Menu.Item key='delete'>删除："{this.state.leftSiderContextNode.title}"</Menu.Item>
                <Menu.Item key='rename'>重命名</Menu.Item>
                <SubMenu key='move' title='移动到'>
                    {dirs.map(dir => <Menu.Item
                        key={`move-to-${dir.id}`}
                        icon={<FolderOutlined />}
                    >{dir.name}</Menu.Item>)}
                    <Menu.Item key='move-to-root'>根目录</Menu.Item>
                </SubMenu>
            </Menu>;
        } else if (this.state.leftSiderContextNode?.key?.startsWith('dir-')) {
            const { id, name } = this.state.leftSiderContextNode.value;
            leftSiderContextMenu = <Menu onClick={e => {
                switch (e.key) {
                    case 'rename': {
                        const onOk = async value => {
                            if (isNotEmpty(value)) {
                                await this.onRenameDir(id, value);
                            }
                        };

                        this.setState(({ confirmInputModal }) => {
                            confirmInputModal.value = name;
                            confirmInputModal.visible = true;
                            confirmInputModal.title = '输入文件夹名称'
                            confirmInputModal.onOk = onOk;
                            return { confirmInputModal };
                        });
                    } break;
                    case 'delete': {
                        const onOk = () => { this.onDeleteDir(id) }
                        Modal.confirm({
                            title: '是否删除指定的文件夹？',
                            content: '文件夹下的文件也会删除。',
                            okButtonProps: { danger: true },
                            okText: '删除',
                            onOk
                        });
                    } break;
                    default:
                        break;
                }
            }}>
                <Menu.Item key='rename'>重命名</Menu.Item>
                <Menu.Item key='delete'>删除</Menu.Item>
            </Menu>;
        } else if (this.state.leftSiderContextNode?.key?.endsWith('-saved-files') || this.state.leftSiderContextNode?.key === 'ODPS-dev-scripts') {
            let syntaxAndProjectName = this.state.leftSiderContextNode.value;
            if (syntaxAndProjectName === undefined) {
                const key = this.state.leftSiderContextNode.key;
                syntaxAndProjectName = { projectName: key.substring(0, key.length - 12) };
            }
            const onOk = value => this.onMkDir(syntaxAndProjectName, value);
            leftSiderContextMenu = <Menu onClick={e => {
                switch (e.key) {
                    case 'mkdir':
                        this.setState(({ confirmInputModal }) => {
                            confirmInputModal.value = '';
                            confirmInputModal.visible = true;
                            confirmInputModal.title = '输入文件夹名称'
                            confirmInputModal.onOk = onOk;
                            return { confirmInputModal };
                        });
                        break;
                    default:
                        break;
                }
            }}>
                <Menu.Item key='mkdir'>新建文件夹</Menu.Item>
            </Menu>;
        }

        if (this.state.leftSiderContextNode?.value?.origin === 'ODPS') {
            const value = this.state.leftSiderContextNode.value;
            leftSiderContextMenu = <Menu>
                <Menu.Item key='view'><a href={`/data_map/schema_desc/detail/${value.name}`} target="_bank">查看详情</a></Menu.Item>
            </Menu>
        }

        let dataProps = <></>;
        if (this.state.files.length > 0) {
            dataProps = <div style={{ margin: '4px' }}>
                {this.getCurrentFile()?.scriptId > 0
                    ? <>
                        <Button
                            type='link'
                            icon={<EditOutlined />}
                            onClick={this.openDataDevEditor.bind(this)}
                        >脚本配置</Button>
                    </>
                    : <>
                        {
                            this.state.activeDataOrigin === 'MaxCompute'
                                ? <>
                                    <Tag color='#096dd9'>Maxcompute</Tag>
                                    <span>{"/ "}</span>
                                    <Tag color='#a0d911'>{this.state.activeProject}</Tag>
                                </>
                                : <>
                                    <Tag color='#fa8c16'>Hologress</Tag>
                                    <span>{"/ "}</span>
                                    <Tag color='#a0d911'>{this.state.activeProject}</Tag>
                                </>
                        } {
                            this.state.activeDataOrigin === 'MaxCompute'
                                ? <>
                                    <span> </span>
                                    <MaxComputeIcon />
                                    <a href='https://help.aliyun.com/document_detail/27860.html' rel="noreferrer" target='_blank' >帮助</a>
                                </>
                                : <>
                                    <span> </span>
                                    <HologresIcon />
                                    <a href='https://help.aliyun.com/zh/hologres/user-guide/developer-guide/' rel="noreferrer" target='_blank' >帮助</a>
                                </>
                        }
                    </>}
            </div>
        }

        const addSqlMenu = (<Menu>
            <SubMenu title="MaxCompute(MySQL语法)" icon={<MaxComputeIcon />}>
                {
                    this.state.projects?.ODPS?.map(p =>
                        <Menu.Item key={'MaxCompute-' + p} onClick={() => this._prepareAddFile('MaxCompute', p)}>{p}</Menu.Item>
                    )
                }
            </SubMenu>
            <SubMenu title="Hologres(Postgre语法)" icon={<HologresIcon />}>
                {
                    this.state.projects?.Hologres?.map(p =>
                        <Menu.Item key={'Hologres-' + p} onClick={() => this._prepareAddFile('Hologres', p)}>{p}</Menu.Item>
                    )
                }
            </SubMenu>
            <Menu.Item key='Script' icon={<SettingOutlined style={{ color: '#52c41a' }} />} onClick={this.prepareAddScript.bind(this)}>
                数据开发脚本
            </Menu.Item>
        </Menu>)
        const addSqlTab = <Dropdown overlay={addSqlMenu} ><PlusOutlined /></Dropdown>
        return <>
            <Prompt message="文件还未保存，确定要离开此页面吗?" when={this.contentDirty} />
            <Layout>
                <Layout.Sider theme="light" width={document.body.clientWidth * 0.2} style={{ margin: '10px' }}>
                    <Tabs
                        size='small'
                        defaultActiveKey='query'
                        type="card"
                    >
                        <Tabs.TabPane
                            tab={<><CodeOutlined />数据查询</>}
                            key="query"
                        >
                            <Row>
                                <Col flex="auto">
                                    <Tooltip
                                        color='#f50'
                                        placement='right'
                                        trigger={['hover']}
                                        title='表信息查询'
                                        visible={this.state.hint}
                                    >
                                        <Input.Search
                                            placeholder="请输入需要查询的表名/脚本名"
                                            value={this.state.schemaKey}
                                            onSearch={(value, _e) => this.fetchOwnedSchemasTree(value)}
                                            onChange={e => this.fetchOwnedSchemasTree(e?.target?.value)} />
                                    </Tooltip>
                                </Col>
                                <Col>
                                    <Button
                                        icon={<RedoOutlined />}
                                        onClick={() => this.fetchOwnedSchemasTree(this.state.schemaKey, true)}
                                    />
                                </Col>
                            </Row>
                            <div style={{ height: 10 }}></div>
                            <Row>
                                <Col flex="100%">
                                    <Dropdown
                                        overlay={leftSiderContextMenu}
                                        trigger={['contextMenu']}
                                    >
                                        <Tree
                                            style={{
                                                width: 'auto',
                                                overflowX: 'auto',
                                                height: this.state.clientHeight - 167,
                                                overflowY: 'auto',
                                                wordBreak: 'keep-all',
                                                whiteSpace: 'nowrap',
                                                border: '1px solid #f0f0f0'
                                            }}
                                            defaultExpandAll
                                            showIcon
                                            virtual
                                            switcherIcon={<DownOutlined />}
                                            treeData={this.state.schemasTree}
                                            expandedKeys={this.state.extendedKeys}
                                            onExpand={keys => this.setState({ extendedKeys: keys })}
                                            onMouseEnter={this.onLeftSiderTreeMouseEnter.bind(this)}
                                            onMouseLeave={() => this.setState({ leftSiderTreeHintVisible: false })}
                                            onDoubleClick={this.onLeftSiderTreeDoubleClick.bind(this)}
                                            onSelect={(_, { selected, node }) => {
                                                if (selected) {
                                                    this.setState({ leftSiderSelectedNode: node });
                                                }
                                            }}
                                            onRightClick={({ node }) => this.setState({ leftSiderContextNode: node })}
                                        />
                                    </Dropdown>
                                </Col>
                            </Row>
                        </Tabs.TabPane>
                        <Tabs.TabPane
                            tab={<Tooltip
                                color='#f50'
                                placement='top'
                                trigger={['hover']}
                                title='数据开发功能在此处'
                                visible={this.state.hint}
                            >
                                <SettingOutlined />数据开发
                            </Tooltip>}
                            key="dev"
                        >
                            <Row>
                                <Col flex="auto">
                                    <Tooltip
                                        color='#f50'
                                        placement='right'
                                        trigger={['hover']}
                                        title='开发脚本信息查询'
                                        visible={this.state.hint}
                                    >
                                        <Input.Search
                                            placeholder="请输入需要查询的脚本名"
                                            value={this.state.devScriptKey}
                                            onSearch={(value, _e) => this.fetchOwnedDevScriptsTree(value)}
                                            onChange={e => this.fetchOwnedDevScriptsTree(e?.target?.value)} />
                                    </Tooltip>
                                </Col>
                            </Row>
                            <div style={{ height: 10 }}></div>
                            <Row>
                                <Col flex="100%">
                                    <Dropdown
                                        overlay={leftSiderContextMenu}
                                        trigger={['contextMenu']}
                                    >
                                        <Tree
                                            style={{
                                                width: 'auto',
                                                overflowX: 'auto',
                                                height: this.state.clientHeight - 125,
                                                overflowY: 'auto',
                                                wordBreak: 'keep-all',
                                                whiteSpace: 'nowrap',
                                                border: '1px solid #f0f0f0'
                                            }}
                                            defaultExpandAll
                                            showIcon
                                            virtual
                                            switcherIcon={<DownOutlined />}
                                            treeData={this.state.devScriptsTree}
                                            onMouseEnter={this.onLeftSiderTreeMouseEnter.bind(this)}
                                            onMouseLeave={() => this.setState({ leftSiderTreeHintVisible: false })}
                                            onDoubleClick={this.onLeftSiderTreeDoubleClick.bind(this)}
                                            onSelect={(_, { selected, node }) => {
                                                if (selected) {
                                                    this.setState({ leftSiderSelectedNode: node });
                                                }
                                            }}
                                            onRightClick={({ node }) => this.setState({ leftSiderContextNode: node })}
                                        />
                                    </Dropdown>
                                </Col>
                            </Row>
                        </Tabs.TabPane>
                    </Tabs>


                </Layout.Sider>

                <Layout.Content style={{ padding: '10px 0px 0px 0px' }}>
                    <Row>
                        <Col>
                            <Space>
                                <Tooltip title="保存(Ctrl/⌘+S)">
                                    <Button
                                        icon={<SaveOutlined />}
                                        onClick={() => this.saveFile(this.state.filesActiveKey)}
                                    />
                                </Tooltip>
                                <Tooltip title="成本">
                                    <Button icon={<DollarOutlined style={{ color: "#faad14" }} />}
                                        disabled={this.isTaskPending() || this.state.estimateSqlCostPending}
                                        onClick={() => this.estimateSqlCost()}
                                    />
                                </Tooltip>
                                {this.getCurrentFile()?.scriptId > 0
                                    ? <>
                                        <Tooltip title="调试(不覆盖表数据，仅查询)">
                                            <Button icon={this.isTaskPending() ? <LoadingOutlined /> : <BugOutlined style={{ color: '#52c41a' }} />}
                                                disabled={this.isTaskPending()}
                                                onClick={() => this.commitSqlTask()}
                                            />
                                        </Tooltip>
                                        <Tooltip title="执行(Ctrl/⌘+Enter)">
                                            <Button icon={this.isTaskPending() ? <LoadingOutlined /> : <CaretRightOutlined />}
                                                disabled={this.isTaskPending()}
                                                onClick={() => this.commitSqlTask(this.getCurrentFile()?.scriptId)}
                                            />
                                        </Tooltip>
                                    </>
                                    : <Tooltip title="执行(Ctrl/⌘+Enter)">
                                        <Button icon={this.isTaskPending() ? <LoadingOutlined /> : <CaretRightOutlined />}
                                            disabled={this.isTaskPending()}
                                            onClick={() => this.commitSqlTask()}
                                        />
                                    </Tooltip>
                                }
                                <Tooltip title="终止">
                                    <Button
                                        icon={<PauseOutlined />}
                                        disabled={!this.isTaskPending() || this.state.task.id === undefined}
                                        onClick={() => this.interruptTask()}
                                    />
                                </Tooltip>
                                <Tooltip title="格式化(Ctrl/⌘+Shift+L)">
                                    <Button
                                        icon={<AppstoreOutlined />}
                                        onClick={this.didSqlFormatted.bind(this)}
                                    />
                                </Tooltip>
                                <Tooltip title="清除">
                                    <Button icon={<DeleteOutlined />} onClick={() => {
                                        window.CyaLogger?.sendClick(null, 'clean_all_sql', { value: {} });
                                        this.monacoInstance?.setValue('');
                                    }} />
                                </Tooltip>
                                <Checkbox
                                    checked={this.state.showCurrentResultOnly}
                                    onChange={({ target: { checked } }) => {
                                        this.setState({ showCurrentResultOnly: checked });
                                        localStorage.setItem('sql.showCurrentResultOnly', checked.toString());
                                    }}
                                >只看当前文件的结果</Checkbox>
                            </Space>
                        </Col>

                        <Col flex="auto" />
                        <Col style={{ alignSelf: 'center' }}>
                            <Tooltip
                                color='#f50'
                                placement='top'
                                trigger={['hover']}
                                title='帮助文件链接在此处'
                                visible={this.state.hint}
                            >
                                <a
                                    href='https://shimo.im/docs/wV3VVx7xYgfZpN3y'
                                    target='_bank'
                                ><QuestionCircleOutlined /> 帮助文档</a>
                            </Tooltip>
                        </Col>
                        <Col flex="10px"></Col>
                        <Col>
                            <Radio.Group
                                options={fontSizeOpts}
                                onChange={(e) => {
                                    const fontSize = parseInt(e.target.value);
                                    Object.keys(this.editors).forEach(domId =>
                                        this.editors[domId].instance.updateOptions({ fontSize }));
                                    this.setState({ fontSize });
                                    localStorage.setItem('sql.fontSize', fontSize);
                                }}
                                defaultValue={this.state.fontSize}
                                value={this.state.fontSize}
                                optionType="button"
                            />
                        </Col>
                        <Col flex="50px"></Col>
                        <Col style={{ alignSelf: 'center', textAlign: 'center', padding: '0px 10px 0px 0px' }}>
                            <Switch
                                checkedChildren="暗黑"
                                unCheckedChildren="白色"
                                onChange={(value) => {
                                    let theme = value ? 'vs-dark' : 'vs-light';
                                    Object.keys(this.editors).forEach(domId =>
                                        this.editors[domId].instance.updateOptions({ theme }));
                                    this.setState({ theme });
                                    localStorage.setItem('sql.theme', theme);
                                }}
                                checked={this.state.theme === 'vs-dark'}
                            />
                        </Col>
                    </Row>
                    <div style={{ height: 10 }}></div>
                    <Row>
                        <Col>
                        <Tabs
                            closable='true'
                            type="editable-card"
                            size="small"
                            activeKey={this.state.filesActiveKey}
                            onChange={key => this.switchFileByKey(key)}
                            onEdit={(targetKey, action) => {
                                if (action === 'add') {
                                    // this._addFileManually();
                                    // do nothing...
                                } else {
                                    this.closeFile(targetKey);
                                }
                            }}
                            tabBarExtraContent={dataProps}
                            addIcon={addSqlTab}
                            style={{ width: this.state.files.length === 0 && '100%' }}
                        >
                            {this.state.files.length === 0 && <Skeleton height={this.state.bottomSiderY} />}
                            {this.state.files.map(file => <Tabs.TabPane
                                tab={<span>{file.syntax === 'ODPS-SQL'
                                    ? (file.scriptId > 0
                                        ? <SettingOutlined style={{ color: '#52c41a' }} />
                                        : <MaxComputeIcon />)
                                    : <HologresIcon />} {file.fileName}</span>}
                                key={file.id}
                            >
                                <MonacoEditorView
                                    domId={file.domId}
                                    done={(instance) => {
                                        this.monacoInstance = instance;
                                        this.onWindowSize();
                                        //this.doSyntaxChecking(this.monacoInstance);
                                    }}
                                    attach={() => this.attachEditor(file)}
                                />
                            </Tabs.TabPane>)}
                        </Tabs>
                        </Col>
                    </Row>
                    <div
                        className="site-h-resize-sider"
                        style={{ height: 7, backgroundColor: this.state.bottomSiderAdjusting ? '#096dd9' : undefined }}
                        onMouseDown={() => this.setState({ bottomSiderAdjusting: true })}
                    ></div>
                    <Row>
                        <Col flex="100%">
                            <Tabs
                                closable="true"
                                hideAdd
                                type="editable-card"
                                size="small"
                                defaultActiveKey="logs"
                                activeKey={this.state.tabsActiveKey}
                                onChange={key => this.setState({ tabsActiveKey: key })}
                                onEdit={(targetKey, action) => {
                                    if (action === 'remove') {
                                        const jobId = Number.parseInt(targetKey.split('-')[1]);
                                        const results = this.state.results;
                                        delete results[jobId];
                                        this.setState({ results });
                                        if (JSON.stringify(results) === '{}') {
                                            this.setState({ tabsActiveKey: 'history' });
                                        }
                                    }
                                }}
                                tabBarExtraContent={
                                    (this.state.tabsActiveKey !== 'logs' && this.state.tabsActiveKey !== 'history') &&
                                    <>
                                        <Button
                                            size='small'
                                            icon={<CopyOutlined />}
                                            type="link"
                                            onClick={() => this.onCopyResult(this.state.tabsActiveKey)}
                                        >复制数据</Button>
                                        <Button
                                            size='small'
                                            icon={<SaveOutlined />}
                                            disabled={this.stillExporting(this.state.tabsActiveKey)}
                                            type="link"
                                            onClick={() => this.onExportResult(this.state.tabsActiveKey)}
                                        >导出数据</Button>
                                    </>
                                }
                            >
                                <Tabs.TabPane tab="查询日志" key="logs" closeIcon>
                                    <LogsView
                                        height={bottomSiderHeight}
                                        isTaskPending={this.isTaskPending()}
                                        preTaskError={this.state.preTaskError}
                                        dataSource={this.state.task.jobs}
                                    />
                                </Tabs.TabPane>
                                <Tabs.TabPane tab="查询历史" key="history" closeIcon>
                                    <HistoryView
                                        height={bottomSiderHeight}
                                        dataSource={this.state.history}
                                        current={this.state.historyPageNo}
                                        pageSize={this.state.historyPageSize}
                                        total={this.state.historyTotal}
                                        onRollback={sql => this.insertToCurrentEditor(`${sql};\n`)}
                                        onPageChange={(page, pageSize) => {
                                            this.fetchJobsHistory(page, pageSize);
                                            this.setState({ historyPageNo: page, historyPageSize: pageSize });
                                        }}
                                        onSearch={(v) => {
                                            console.log("search:" + v)
                                            this.fetchJobsHistory(1, this.state.historyPageSize, v);
                                            this.setState({ historyPageNo: 1 });
                                        }}
                                    />
                                </Tabs.TabPane>
                                {Object.keys(this.state.results)
                                    .map(key => this.state.results[key])
                                    .filter(result => !this.state.showCurrentResultOnly || result.fileId === currentFile?.id)
                                    .map(result => {
                                        return <Tabs.TabPane
                                            tab={this.renderResultTitle(result)}
                                            key={`result-${result.jobId}`}
                                        >
                                            <ResultView
                                                height={bottomSiderHeight}
                                                dataSource={result.rows}
                                                columns={result.columns}
                                                current={result.pageNo}
                                                pageSize={result.pageSize}
                                                total={result.total}
                                                onPageChange={(page, pageSize) => {
                                                    this.fetchResultRows(
                                                        result.jobId,
                                                        result.columns,
                                                        result.total,
                                                        page,
                                                        pageSize);
                                                }}
                                            />
                                        </Tabs.TabPane>;
                                    })}
                            </Tabs>
                        </Col>
                    </Row>
                </Layout.Content>
            </Layout>
            {this.state.leftSiderTreeHintVisible && <div
                className="ant-popover ant-popover-placement-right"
                style={{
                    position: 'fixed',
                    top: this.state.leftSiderTreeHintTop,
                    left: this.state.leftSiderTreeHintLeft,
                    transformOrigin: '50% 92px',
                    backgroundColor: this.state.leftSiderTreeHintColor,
                    color: '#ffffff',
                    padding: '4px 3px 4px 3px'
                }}
            >
                <div className="ant-popover-content">
                    <div className="ant-popover-arrow" style={{
                        left: -4,
                        borderLeftColor: this.state.leftSiderTreeHintColor,
                        borderBottomColor: this.state.leftSiderTreeHintColor
                    }}></div>
                    <span>{this.state.leftSiderTreeHintContent}</span>
                </div>
            </div>}
            <Modal
                title={<span>{this.state.estimateSqlCostPending && <LoadingOutlined />} 成本</span>}
                visible={this.state.estimateSqlCostVisible}
                onOk={() => this.setState({ estimateSqlCostVisible: false })}
                onCancel={() => this.setState({ estimateSqlCostVisible: false })}
            >
                <Table
                    loading={this.state.estimateSqlCostPending}
                    dataSource={this.state.taskCost}
                    pagination={false}
                    size="small"
                >
                    <Table.Column
                        title="查询"
                        dataIndex="sql"
                        width={200}
                        ellipsis
                    />
                    <Table.Column
                        title="复杂度"
                        dataIndex="complexity"
                    />
                    <Table.Column
                        title="输入"
                        dataIndex="input"
                        render={(input) => <span>{(input / 1073741824.0).toFixed(2)} GB</span>}
                    />
                    <Table.Column
                        title="成本"
                        dataIndex="money"
                        render={(money) => <code style={{ color: 'red' }}>¥{money}</code>}
                    />
                </Table>
            </Modal>
            <Modal 
                title="错误信息" 
                visible={this.state.treeDevScriptErrorVisible}
                onOk={() => this.setState({ treeDevScriptErrorVisible: false })} 
                onCancel={() => this.setState({ treeDevScriptErrorVisible: false })}
            >
                <LogsView
                    height={300}
                    isTaskPending={false}
                    preTaskError={'OK'}
                    dataSource={this.state.currentDevJobs}
                />
            </Modal>
            {this.state.confirmFileNameVisible && <ConfirmFileNameModal
                visible={this.state.confirmFileNameVisible}
                onOk={this.onConfirmFileNameOk.bind(this)}
                onCancel={() => {
                    this.setState({ confirmFileNameVisible: false });
                    if (this.state.confirmFileNameAction === 'add+close') {
                        this.closeTag(this.state.confirmFileKey);
                    } else {
                        this.getCurrentFile()?.editor?.instance?.focus();
                    }
                }}
                value={this.state.confirmFileName}
                error={this.state.confirmFileNameError}
                onChange={e => {
                    this.checkConfirmFileName(e.target.value);
                    this.setState({ confirmFileName: e.target.value });
                }}
            />}
            {this.state.confirmInputModal.visible && <ConfirmInputModal
                visible={this.state.confirmInputModal.visible}
                title={this.state.confirmInputModal.title}
                value={this.state.confirmInputModal.value}
                onOk={value => {
                    this.state.confirmInputModal.onOk(value);
                    this.setState(({ confirmInputModal }) => {
                        confirmInputModal.visible = false;
                        confirmInputModal.value = value;
                        return { confirmInputModal };
                    });
                }}
                onCancel={() => this.setState(({ confirmInputModal }) => {
                    confirmInputModal.visible = false;
                    return { confirmInputModal };
                })}
            />}
            {this.state.tableSchemaModal.visible && <TableSchemaModal
                {...this.state.tableSchemaModal}
                onCommit={() => {
                    this.setState(({ tableSchemaModal }) => {
                        tableSchemaModal.visible = false;
                        return { tableSchemaModal };
                    })
                }}
                onCancel={() => {
                    this.setState(({ tableSchemaModal }) => {
                        tableSchemaModal.visible = false;
                        return { tableSchemaModal };
                    })
                }}
            />}
            {this.state.dataDevEditor.visible && <EditTaskModal
                {...this.state.dataDevEditor}
                onOk={async (params, addOrUpdate) => {
                    await this.commitDataDevScript(params, addOrUpdate);
                    this.setState(({ dataDevEditor }) => {
                        dataDevEditor.visible = false;
                        return { dataDevEditor };
                    });
                }}
                onCancel={() => this.setState(({ dataDevEditor }) => {
                    dataDevEditor.visible = false;
                    return { dataDevEditor };
                })}
            />}
            {this.state.generateDDLModal.visible && <GenerateDDLModal
                {...this.state.generateDDLModal}
                onCancel={() => this.setState(({ generateDDLModal }) => {
                    generateDDLModal.visible = false;
                    return { generateDDLModal };})}
            />}
        </>
    }

    static tooltipColors = [
        'pink',
        'red',
        'yellow',
        'orange',
        'cyan',
        'green',
        'blue',
        //'purple',
        'geekblue',
        'magenta',
        'volcano',
        'gold',
        'lime',
    ];

    renderResultTitle(result) {
        // isEmpty(result.title) ? `查询结果[${result.index}]` : result.title
        if (result.renaming) {
            return <Input
                value={result.title}
                size='small'
                onChange={({ target: { value } }) => this.setState(({ results }) => {
                    result.title = value;
                    return { results };
                })}
                onPressEnter={() => this.setState(({ results }) => {
                    result.renaming = false;
                    return { results };
                })}
                style={{ width: '100%', minWidth: 200 }}
            >
            </Input>;
        } else {
            const color = QueryingWorksView.tooltipColors[Number.parseInt(result.fileId) % QueryingWorksView.tooltipColors.length];
            //console.log(color);
            return <Tooltip
                title={result?.sql?.length > 500 ? `${result?.sql?.substring(0, 500)}...` : result.sql}
                color={this.state.showCurrentResultOnly ? undefined : color}
                mouseEnterDelay={0.3}
                overlayStyle={{ fontSize: 12 }}
            >
                <span
                    onDoubleClick={() => this.setState(({ results }) => {
                        result.renaming = true;
                        return { results };
                    })}
                >
                    {isEmpty(result.title) ? `查询结果[${result.index}]` : result.title}
                </span>
            </Tooltip>;
        }
    }

    insertToCurrentEditor(text) {
        const instance = this.getCurrentFile()?.editor?.instance;
        if (instance === undefined) {
            return;
        }
        const selection = instance.getSelection();
        const id = { major: 1, minor: 1 };
        const op = { identifier: id, range: selection, text, forceMoveMarkers: true };
        instance.executeEdits("insert", [op]);
        instance.focus();
    }

    onLeftSiderTreeDoubleClick() {
        const node = this.state.leftSiderSelectedNode;
        if (!node) {
            return;
        }
        if (node.key.startsWith('file-')) {
            // 文件结点
            this.openFile(node.key.substring(5));
        } else if (node.value?.level != null) {
            // 表结点
            if (!this._checkOriginAndProject(node.value)) {
                return
            }

            const partitions = node.value.partitions;
            if (partitions.length && partitions.length > 0) {
                let whereClause = `${partitions[0]} = ''`;
                for (let i = 1; i < partitions.length; i++) {
                    whereClause += `AND ${partitions[i]} = ''`;
                }
                let sql = `-- 分区表必须指定分区字段\nSELECT * FROM ${node.value.name} WHERE ${whereClause} LIMIT 200;\n`
                this.insertToCurrentEditor(sql);
            } else {
                let tableName = node.value.name
                // Hologres 空间表明需要带上 schema 名称
                if (node.value?.origin === 'Hologres') {
                    tableName = `${node.value.level}.${node.value.name}`;
                }
                this.insertToCurrentEditor(`SELECT * FROM ${tableName} LIMIT 200;\n`);
            }

        } else if (isNotEmpty(node.value?.type)) {
            // 列结点
            if (!this._checkOriginAndProject(node.value)) {
                return
            }

            let schemaName = node.key.split('-')[1].split('.')[0];
            // Hologres 空间表明需要带上 schema 名称
            if (node.value?.origin === 'Hologres') {
                schemaName = this._generateHologresTableName(schemaName)
            }
            this.insertToCurrentEditor(`SELECT * FROM ${schemaName} WHERE ${node.value.name} = '';\n`);
        }
    }

    _generateHologresTableName(tableName) {
        const idx = tableName.indexOf('_')
        if (idx > 0) {
            return tableName.substring(0, idx) + "." + tableName
        }
        return tableName
    }

    _checkOriginAndProject(schema) {
        // console.info(schema)
        if (schema != null && schema.projectName === this.state.activeProject) {
            if (this.state.activeDataOrigin === 'MaxCompute' && schema.origin === 'ODPS') {
                return true
            }
            if (this.state.activeDataOrigin === schema.origin) {
                return true
            }
        }

        message.error(`当前Tab仅支持数据源为 ${this.state.activeDataOrigin} ${this.state.activeProject !== '' ? '，空间为' + this.state.activeProject : ''} 的数据表查询`)
        return false;

    }

    onLeftSiderTreeMouseEnter(e) {
        const rect = e.event.target.getBoundingClientRect();
        if (e.node.value?.comment && e.node.value.comment !== 'null') {
            const owner = e.node.value.owner;
            const comment = e.node.value.comment
            const showOwner = false
            this.setState({
                leftSiderTreeHintVisible: true,
                leftSiderTreeHintTop: rect.y - 5,
                leftSiderTreeHintLeft: rect.x + rect.width + 20,
                leftSiderTreeHintColor: '#389e0d',
                leftSiderTreeHintContent: showOwner ? `${comment} <负责人: ${owner.match(/^RAM\$\w+@aliyun.com:(\w+)$/)[1]}>` : comment
            });
        } else if (e.node.value?.fileName) {
            this.setState({
                leftSiderTreeHintVisible: true,
                leftSiderTreeHintTop: rect.y - 5,
                leftSiderTreeHintLeft: rect.x + rect.width + 20,
                leftSiderTreeHintColor: '#faad14',
                leftSiderTreeHintContent: `v${e.node.value.version} at ${e.node.value.updatedAt}`
            });
        }
    }

    onConfirmFileNameOk() {
        if (!this.checkConfirmFileName(this.state.confirmFileName)) {
            return;
        }
        switch (this.state.confirmFileNameAction) {
            case 'add':
                this.newFile(this.state.filesActiveKey);
                break;
            case 'add+close':
                this.newFile(this.state.confirmFileKey, true);
                this.closeTag(this.state.confirmFileKey);
                break;
            case 'rename':
                this.renameFile(this.state.confirmFileKey, this.state.confirmFileName);
                break;
            default:
                break;
        }
        this.setState({ confirmFileNameVisible: false });
        this.getCurrentFile()?.editor?.instance?.focus();
    }

    async checkConfirmFileName(name) {
        if (isEmpty(name)) {
            this.setState({ confirmFileNameError: '文件名不能为空。' });
            return false;
        }

        const maybeExists = await this.loadFileByName(name);
        if (this.state.confirmFileNameAction === 'rename') {
            if (maybeExists && maybeExists.id.toString() !== this.state.confirmFileKey.toString()) {
                this.setState({ confirmFileNameError: '文件名不能重复。' });
                return false;
            }
        } else {
            if (maybeExists) {
                this.setState({ confirmFileNameError: '文件名不能重复。' });
                return false;
            }
        }
        this.setState({ confirmFileNameError: undefined });
        return true;
    }

    async loadFileByName(name) {
        return await UIFetchService.get(`/api/v1/querying_works/owned/file/names/${encodeURI(name)}?projectName=${this.state.activeProject}`);
    }

    switchFileByKey(key) {
        //console.log(this.editors);
        if (typeof key === 'string') {
            key = Number.parseInt(key);
        }
        const file = this.state.files.find(file => file.id === key);
        if (!file) {
            return;
        }
        this.setState({
            filesActiveKey: key.toString(),
            activeDataOrigin: file.origin,
            activeProject: file.projectName
        });
        if (file && file.domId in this.editors) {
            this.monacoInstance = this.editors[file.domId].instance;
            this.monacoInstance.focus();
            this.onWindowSize();
        }
    }

    attachEditor(file) {
        const monacoDomNode = document.getElementById(file.domId);

        if (monacoDomNode.attributes["data-mode-id"] !== undefined && file.domId in this.editors) {
            return this.editors[file.domId].instance;
        }
        if (file.domId in this.editors) {
            this.editors[file.domId].instance.dispose();
        }

        const instance = monaco.editor.create(monacoDomNode, {
            value: isEmpty(file.content) ? '' : file.content,
            theme: this.state.theme,
            fontSize: this.state.fontSize,
            language: 'sql',
            automaticLayout: true
        });
        this.editors[file.domId] = {
            instance,
            key: file.id,
            contentDirty: false,
            syntaxCheckingDirty: true
        };

        instance.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyMod.Shift | monaco.KeyCode.KEY_L,
            this.didSqlFormatted.bind(this));
        instance.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter, async () => {
            this.commitSqlTask()
        });
        instance.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KEY_S, async () => this.saveFile(this.state.filesActiveKey));
        // instance.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyMod.Shift | monaco.KeyCode.KEY_S,
        //     async () => this.state.files.forEach(({ id }) => this.saveFile(id)));

        instance.onDidChangeModelContent(_ => {

            this.editors[file.domId].contentDirty = true;
            this.editors[file.domId].syntaxCheckingDirty = true;
            //this.setState({ contentDirty: true });
            this.contentDirty = true;
        });
        return instance;
    }

    prepareAddScript() {
        this.setState(({ dataDevEditor }) => {
            dataDevEditor.visible = true;
            dataDevEditor.addOrUpdate = true;
            return { dataDevEditor };
        });
    }

    async openDataDevEditor() {
        const scriptId = this.getCurrentFile()?.scriptId;
        if (!(scriptId > 0)) {
            return;
        }

        const job = await UIFetchService.get(`/api/v1/querying_works/dev/jobs/${scriptId}`);
        this.setState(({ dataDevEditor }) => {
            dataDevEditor.visible = true;
            dataDevEditor.addOrUpdate = false;
            dataDevEditor.data = job;
            dataDevEditor.id = scriptId;
            return { dataDevEditor };
        });
    }

    async commitDataDevScript(task, addOrUpdate) {
        if (addOrUpdate) {
            const rv = await UIFetchService.post(`/api/v1/querying_works/dev/jobs`, task);
            if (rv === null || rv === undefined) {
                return;
            }
            const { fileId } = rv;
            this.openFile(fileId);
        } else {
            await UIFetchService.put(`/api/v1/querying_works/dev/jobs/${this.state.dataDevEditor.id}`, task);
        }
        this.setState(({ dataDevEditor }) => {
            dataDevEditor.pending = false;
            return { dataDevEditor };
        });
        this.fetchOwnedDevScriptsTree("");
    }

    _prepareAddFile(origin, projectName) {
        // MaxCompute
        // Hologres
        notification.open({
            message: '提示',
            description: origin === 'MaxCompute'
                ? <span><MaxComputeIcon />创建查询文件为MaxCompute数据源，请使用MaxCompute SQL语法</span>
                : <span><HologresIcon />创建查询文件为Hologres数据源，请使用Postgre-SQL语法</span>,
            onClick: () => { },
        });
        this.setState({
            addFileContext: {
                origin: origin,
                projectName: projectName
            }
        }, () => {
            this._addFileManually(origin, projectName)
        })
    }

    _addFileManually(origin, projectName) {
        if (this.state.addFileContext == null) {
            return;
        }
        this.setState({
            addFileContext: null,
            activeDataOrigin: origin,
            activeProject: projectName
        })
        this.addFile(undefined, undefined, origin, projectName)
    }

    addFile(fileName, content, origin, projectName) {
        const files = this.state.files;
        const id = this.spawnFile(fileName, content, files, origin, projectName);
        this.setState({ files });
        this.saveTags(files);
        this.switchFileByKey(id);
    }

    spawnFile(fileName, content, files, origin, projectName) {
        let id = -1;
        while (files.find(file => file.id === id) !== undefined) {
            id--;
        }
        const syntax = origin === 'MaxCompute' ? 'ODPS-SQL' : 'HOLO-SQL';
        files.push({
            id,
            domId: `monaco-${QueryingWorksView.sequenceNumber++}`,
            fileName: fileName ? fileName : `untitle${id}`,
            syntax: syntax,
            content: content ? content : '',
            origin: origin,
            projectName: projectName
        });
        return id;
    }

    closeFile(key) {
        const file = this.findFile(key);
        if (!file) {
            return;
        }
        if (file.editor?.contentDirty || file.id <= 0) {
            const onOk = () => {
                this.saveFile(key);
                this.closeTag(key);
            };
            const onCancel = () => { };
            if (file.id <= 0) {
                this.showConfirmFileNameModal(file.fileName, 'add+close', key);
                return;
            }
            Modal.confirm({
                title: '文件已被修改，是否保存？',
                icon: <ExclamationCircleOutlined />,
                okText: '是',
                okType: 'primary',
                cancelText: '否',
                onOk,
                onCancel,
            });
            return;
        }

        this.closeTag(key);
    }

    closeTag(key) {
        this.setState(({ files }) => {
            files = files.filter(file => file.id.toString() !== key.toString());
            if (files.length > 0) {
                this.switchFileByKey(files[files.length - 1].id);
            } else {

            }
            this.saveTags(files);
            return { files };
        });
    }

    async deleteFile(key, file) {
        window.CyaLogger?.sendClick(null, 'delete_sql_file', { value: { key: key } });

        const onOk = async () => {
            await UIFetchService.method('DELETE', `/api/v1/querying_works/owned/files/${key}`);
            const { parent, target } = this.findSchemasTreeNode(this.state.schemasTree, `file-${key}`);
            if (target === undefined) {
                return;
            }
            this.setState(({ schemasTree }) => {
                parent.children = parent.children.filter(node => node.key !== target.key);
                return { schemasTree: [...schemasTree] };
            });
            this.fetchOwnedDevScriptsTree('');
            await this.invalidateCache();
            this.closeTag(key);
            message.info('文件已删除。')
        };
        Modal.confirm({
            title: `是否删除文件”${file === undefined ? '' : file.fileName}“？`,
            icon: <ExclamationCircleOutlined />,
            okText: '删除',
            okButtonProps: { danger: true },
            okType: 'primary',
            onOk,
        });
    }

    showConfirmFileNameModal(fileName, action, key) {
        this.setState({
            confirmFileNameVisible: true,
            confirmFileName: fileName,
            confirmFileKey: key,
            confirmFileNameAction: action,
            confirmFileNameError: undefined
        });
        //document.getElementById('confirm-file-name')?.focus();
    }

    async saveFile(key) {
        window.CyaLogger?.sendClick(null, 'save_sql_file', { value: { key: key } });
        let file = this.findFile(key);
        if (file === undefined) {
            return;
        }

        if (file.id <= 0) {
            this.showConfirmFileNameModal(file.fileName, 'add');
            return;
        }
        if (file.editor) {
            file.editor.contentDirty = false;
            this.contentDirty = this.hasAnyFileDirty();
            // this.setState({ contentDirty: this.hasAnyFileDirty() });
        }

        //console.log(file);
        const content = file.editor?.instance?.getValue();
        const id = await UIFetchService.method('PUT', `/api/v1/querying_works/owned/files/${key}`, {
            fileName: file.fileName,
            content: Base64.encode(ifEmpty(content, '')),
            syntax: file.syntax,
            version: 0,
            createdAt: '',
            updatedAt: '',
            projectName: file.projectName
        });
        if (id === undefined || id <= 0) {
            return;
        }
        message.info('保存成功。');
    }

    async newFile(key, afterClose) {
        let file = this.findFile(key);
        if (file === undefined) {
            return;
        }

        const content = file.editor?.instance?.getValue();
        const fileDummy = {
            fileName: this.state.confirmFileName,
            syntax: file.syntax,
            content: Base64.encode(ifEmpty(content, '')),
            version: 0,
            createdAt: '',
            updatedAt: '',
            projectName: file.projectName
        };
        const id = await UIFetchService.method('PUT', `/api/v1/querying_works/owned/files/0`, fileDummy);
        if (id === undefined || id <= 0) {
            return;
        }

        if (!afterClose) {
            this.setState(({ files }) => {
                file = files.find(file => file.id.toString() === key.toString());
                file.id = id;
                file.content = content;
                file.fileName = this.state.confirmFileName;
                this.saveTags(files);
                return { files };
            });
            this.switchFileByKey(id);
        }

        const { target } = this.findSchemasTreeNode(this.state.schemasTree, `${file.projectName}-saved-files`);
        if (target === undefined) {
            return;
        }
        this.setState(({ schemasTree }) => {
            target.children.push({
                title: fileDummy.fileName,
                key: `file-${id}`,
                value: { ...fileDummy, id },
                icon: <FileTextOutlined style={{ color: '#1890ff' }} />,
                children: null
            });
            return { schemasTree: [...schemasTree] };
        });
        await this.invalidateCache();
        message.info('保存成功。');
    }

    async openFile(key) {
        let file = this.findFile(key);
        if (file) {
            this.switchFileByKey(key);
            return;
        }

        file = await UIFetchService.get(`/api/v1/querying_works/owned/files/${key}`);
        if (!file) {
            return;
        }
        file.origin = file.syntax === 'ODPS-SQL' ? 'MaxCompute' : 'Hologres'
        this.setState(({ files }) => {
            file.domId = `monaco-${QueryingWorksView.sequenceNumber++}`;
            files.push(file);
            this.saveTags(files);
            return { files };
        });
        this.switchFileByKey(key);
    }

    async renameFile(key, newName) {
        await UIFetchService.post(`/api/v1/querying_works/owned/files/${key}/name`, { newName: newName, projectName: this.state.activeProject });

        this.setState(({ files }) => {
            const file = files.find(file => file.id.toString() === key.toString());
            if (file) {
                file.fileName = newName;
            }
            return { files };
        });
        this.fetchOwnedSchemasTree(this.state.schemaKey, true);
        this.fetchOwnedDevScriptsTree("");
    }

    getCurrentFile() {
        return this.findFile(this.state.filesActiveKey);
    }

    findFile(key) {
        const file = this.state.files.find(file => file?.id?.toString() === key?.toString());
        if (file === undefined) {
            return;
        }
        const editor = this.editors[file.domId];
        return { ...file, editor };
    }

    hasAnyFileDirty() {
        let dirty = 0;
        Object.keys(this.editors).forEach(domId => {
            const ed = this.editors[domId];
            // if (ed.key > 0 && ed.contentDirty) {
            //     this.saveFile(ed.key.toString());
            // }
            //console.log(ed);
            if (ed.contentDirty) {
                dirty++;
            }
        });
        return dirty > 0;
    }

    // didSqlSyntaxChanged(syntax) {
    //     const file = this.state.files.find(file => file?.id?.toString() === this.state.filesActiveKey?.toString());
    //     if (file === undefined) {
    //         return;
    //     }

    //     const files = this.state.files;
    //     file.syntax = syntax;
    //     this.setState({ files });

    //     localStorage.setItem('sql.syntax', syntax);
    // }

    didSqlFormatted() {
        window.CyaLogger?.sendClick(null, 'sql_format', { value: {} });

        const range = this.monacoInstance?.getSelection();
        let text = this.monacoInstance?.getModel().getValueInRange(range);
        let inRange = true;
        if (text === '' || typeof text !== 'string') {
            text = this.monacoInstance?.getValue();
            inRange = false;
        }

        text = format(text, {
            indent: '    ',
            uppercase: true,
            linesBetweenQueries: 2
        });

        if (inRange) {
            const id = { major: 1, minor: 1 };
            const op = { identifier: id, range, text, forceMoveMarkers: true };
            this.monacoInstance?.executeEdits("insert", [op]);
        }
    }

    buildSchemasTree(schemasTree) {
        if (!schemasTree) {
            return [];
        }
        // this.schemaDirs = {};
        return schemasTree.map(origin => {
            origin.selectable = false
            if (origin.key === "origin-MaxCompute") {
                origin.icon = <MaxComputeIcon />
            } else if (origin.key === "origin-Hologres") {
                origin.icon = <HologresIcon />;
            }
            origin.children = origin.children.map(project => {
                project.icon = <HomeOutlined style={{ color: '#389e0d' }} />
                project.selectable = false
                project.children = project.children.map(level =>
                    this._mapSchemaLevel(origin.key === "origin-MaxCompute" ? 'MaxCompute' : 'Hologres', level))
                return project
            })
            return origin
        });
    }

    // ...菜单中点击设置
    async editDevScriptConf(scriptId) {
        const job = await UIFetchService.get(`/api/v1/querying_works/dev/jobs/${scriptId}`);
        this.setState(({ dataDevEditor }) => {
            dataDevEditor.visible = true;
            dataDevEditor.addOrUpdate = false;
            dataDevEditor.data = job;
            dataDevEditor.id = scriptId;
            return { dataDevEditor };
        });
    }

    // 将任务切换为不是定时任务
    async switchDevScriptOpen(node) {
        const scriptId = node.value.scriptId;
        if (!scriptId) return;
        const job = await UIFetchService.get(`/api/v1/querying_works/dev/jobs/${scriptId}`);
        await UIFetchService.put(`/api/v1/querying_works/dev/jobs/${scriptId}`, {
            ...job,
            scheduledAt: null
        });
        this.fetchOwnedDevScriptsTree("");
    }

    // 重跑脚本
    async replayScript(node, force = false) {
        try {
            const file = await UIFetchService.get(`/api/v1/querying_works/owned/files/${node.value.id}`);
            if (!file) {
                return;
            }
            file.origin = file.syntax === 'ODPS-SQL' ? 'MaxCompute' : 'Hologres';
            const scriptId = node.value.scriptId;
            const request = {
                sql: Base64.encode(file.content),
                syntax: file?.syntax,
                projectName: this.state.activeProject
            };
            let result;
            let query = '';
            if (scriptId > 0) {
                query = `?scriptId=${scriptId}`;
            }
            if (force) {
                if (scriptId > 0) {
                    query = `${query}&force=true`;
                } else {
                    query = `?force=true`;
                }
            }
            result = await UIFetchService.post(`/api/v1/querying_works/tasks/commit${query}`, request);
            // 检查报错
            if (typeof result?.taskId !== 'number') {
                message.error(result?.message) 
            }
            // 更新树
            this.fetchOwnedDevScriptsTree("");
            // 监听任务运行
            result?.taskId && this.poolDevTasksLeft(result?.taskId, scriptId);
        } catch (e) {
            message.error(e.toString())            
        }
    } 

    poolDevTasksLeft(taskId, scriptId) {
        // timer scriptId taskId
        const devTaskPending = this.state.devTaskPending;
        // 判断当前是否有任务在运行，如果有，那么终止监听&终止任务？
        if (devTaskPending.some((task) => task.scritpId === scriptId)) {
            const index = devTaskPending.findIndex((task) => task.scritpId === scriptId);
            if (index !== -1) {
                clearInterval(devTaskPending[index].timer);
                devTaskPending.splice(index, 1);
                // todo: 终止任务？
            }
        }
        const timer = setInterval(async () => {
            try {
                // 监听到完成就重新获取树
                const task = await UIFetchService.get(`/api/v1/querying_works/owned/tasks/${taskId}`);
                if (task.state === 'OK' || task.state === 'FAIL') {
                    this.fetchOwnedDevScriptsTree('')
                    // 记录报错信息
                    clearInterval(timer);
                }
            } catch(e) {
                console.log('监听错误')
                clearInterval(timer)
            }
            // const index = devTaskPending.findIndex((task) => task.scritpId === scriptId);
        }, 1000);
        devTaskPending.push({
            scriptId,
            taskId,
            timer
        })
        this.setState({
            devTaskPending
        })
    }

    // 查询错误信息
    async queryErrInfo(taskId) {
        try {
            // 监听到完成就重新获取树
            const task = await UIFetchService.get(`/api/v1/querying_works/owned/tasks/${taskId}`);
            if (task.state === 'FAIL') {
                // 展示错误信息
                this.setState({
                    treeDevScriptErrorVisible: true,
                    currentDevJobs: task.jobs
                })
            } else {
                message.error('未查询到报错信息')
            }
        } catch(e) {
            message.error(e.toString())
        }
    }

    buildDevScriptsTree(schemasTree) {
        if (!schemasTree) {
            return [];
        }
        this.schemaDirs[`ODPS-DEV/bcz_datap`] = []

        return schemasTree.map(root => {
            root.selectable = false
            if (root.key === "ODPS-dev-scripts") {
                root.icon = <FolderOutlined style={{ color: '#faad14' }} />;
            } else if (root.key === "ODPS-tmp-tables") {
                root.icon = <HomeOutlined style={{ color: '#389e0d' }} />;
            }
            root.children = root.children.map(node => {
                if (node.key.startsWith('file-')) {
                    // 黄圈为正在执行任务，红色叉为执行失败，绿色对号为已完成
                    if (node.value.taskId) {
                        if (node.value.lastTaskState === 'INIT') {
                            node.icon = <RedoOutlined style={{ color: 'yellow' }}/>;
                        } else if (node.value.lastTaskState === 'OK') {
                            node.icon = <CheckCircleOutlined style={{ color: 'green' }} />;
                        } else if (node.value.lastTaskState === 'FAIL') {
                            node.icon = <CloseCircleOutlined style={{ color: 'red' }} />;
                        }
                    }

                    // 定时任务为蓝色，非定时任务为灰色
                    node.title = <div style={{ display: 'inline' }}>
                        <FileTextOutlined style={{ color: node.value.openScheduledStatus === 1 ? '#1890ff' : 'grey' }} />
                        {node.title}
                        <Dropdown overlay={
                            <Menu onClick={async e => {
                                switch (e.key) {
                                    case 'setTimeout':
                                        this.editDevScriptConf(node.value.scriptId)
                                        break;
                                    case 'terminate':
                                        this.switchDevScriptOpen(node)
                                        break;
                                    case 'replay':
                                        this.replayScript(node)
                                        break
                                    case 'delete':
                                        this.deleteFile(node.value.id, node.value)
                                        break
                                    case 'errorInfo':
                                        this.queryErrInfo(node.value.taskId)
                                        break
                                    case 'viewDDL':
                                        this.setState(({ generateDDLModal }) => {
                                            generateDDLModal.visible = true;
                                            generateDDLModal.ddl = node.value.ddl
                                            return { generateDDLModal };
                                        });
                                        break
                                    default:
                                        console.log('未定义行为')
                                        break;
                                }
                            }}>
                                <Menu.Item key='setTimeout'>设置定时任务</Menu.Item>
                                <Menu.Item key='terminate'>终止定时任务</Menu.Item>
                                <Menu.Item key='replay'>重跑脚本</Menu.Item>
                                {/* 脚本错误可以展示错误信息 */}
                                {node.value.lastTaskState === 'FAIL' && node.value.taskId && <Menu.Item key='errorInfo'><span style={{ color: 'red' }}>查看错误信息</span></Menu.Item>}
                                <Menu.Item key='delete'>删除脚本</Menu.Item>
                                <Menu.Item key='viewDDL'>查看建表语句</Menu.Item>
                            </Menu>
                        }>
                            <FormOutlined style={{ color: '#1890ff', marginLeft: '15px' }}></FormOutlined>
                        </Dropdown>
                    </div>
                } else if(node.key.startsWith('dir-')){
                    node.icon = <FolderOutlined style={{ color: '#faad14' }} />;
                    const { syntax, projectName } = node.value;
                    const key = `${syntax}/${projectName}`;
                    let dirs = this.schemaDirs[key];
                    if (dirs === undefined) {
                        dirs = [];
                        this.schemaDirs[key] = dirs;
                    }
                    dirs.push(node.value);
                } else {
                    node.icon = <TableOutlined style={{ color: '#389e0d' }} />;
                }

                if(node.children != null){
                    node.children = node.children.map(leaf => {
                        if (leaf.key.startsWith('file-')) {
                            // 黄圈为正在执行任务，红色叉为执行失败，绿色对号为已完成
                            if (leaf.value.taskId) {
                                if (leaf.value.lastTaskState === 'INIT') {
                                    leaf.icon = <RedoOutlined style={{ color: 'yellow' }}/>;
                                } else if (leaf.value.lastTaskState === 'OK') {
                                    leaf.icon = <CheckCircleOutlined style={{ color: 'green' }} />;
                                } else if (leaf.value.lastTaskState === 'FAIL') {
                                    leaf.icon = <CloseCircleOutlined style={{ color: 'red' }} />;
                                }
                            }
        
                            // 定时任务为蓝色，非定时任务为灰色
                            leaf.title = <div style={{ display: 'inline' }}>
                                <FileTextOutlined style={{ color: leaf.value.openScheduledStatus === 1 ? '#1890ff' : 'grey' }} />
                                {leaf.title}
                                <Dropdown overlay={
                                    <Menu onClick={async e => {
                                        switch (e.key) {
                                            case 'setTimeout':
                                                this.editDevScriptConf(leaf.value.scriptId)
                                                break;
                                            case 'terminate':
                                                this.switchDevScriptOpen(leaf)
                                                break;
                                            case 'replay':
                                                this.replayScript(leaf)
                                                break
                                            case 'delete':
                                                this.deleteFile(leaf.value.id, leaf.value)
                                                break
                                            case 'errorInfo':
                                                this.queryErrInfo(leaf.value.taskId)
                                                break
                                            case 'viewDDL':
                                                this.setState(({ generateDDLModal }) => {
                                                    generateDDLModal.visible = true;
                                                    generateDDLModal.ddl = leaf.value.ddl
                                                    return { generateDDLModal };
                                                });
                                                break
                                            default:
                                                console.log('未定义行为')
                                                break;
                                        }
                                    }}>
                                        <Menu.Item key='setTimeout'>设置定时任务</Menu.Item>
                                        <Menu.Item key='terminate'>终止定时任务</Menu.Item>
                                        <Menu.Item key='replay'>重跑脚本</Menu.Item>
                                        {/* 脚本错误可以展示错误信息 */}
                                        {leaf.value.lastTaskState === 'FAIL' && leaf.value.taskId && <Menu.Item key='errorInfo'><span style={{ color: 'red' }}>查看错误信息</span></Menu.Item>}
                                        <Menu.Item key='delete'>删除脚本</Menu.Item>
                                        <Menu.Item key='viewDDL'>查看建表语句</Menu.Item>
                                    </Menu>
                                }>
                                    <FormOutlined style={{ color: '#1890ff', marginLeft: '15px' }}></FormOutlined>
                                </Dropdown>
                            </div>
                        } else {
                            leaf.icon = <TableOutlined style={{ color: '#389e0d' }} />;
                        }
    
                        return leaf;
                    })
                }

                return node;
            })
            return root;
        });
    }

    _mapSchemaLevel(origin, level) {
        const getFolderColor = (key) => {
            if (key.endsWith('saved-files')) {
                return '#faad14';
            } else {
                return '#389e0d'
            }
        }

        if (!level.key.endsWith("saved-files")) {
            level.title = level.title + "层"
        }
        level.icon = <FolderOutlined style={{ color: getFolderColor(level.key) }} />;

        level.selectable = false;
        level.children = level.children.map(schema => {
            if (schema.key?.startsWith('file-')) {
                let color = '#1890ff';
                if (schema?.value?.syntax === 'HOLO-SQL') {
                    color = '#faad14';
                }
                schema.icon = <FileTextOutlined style={{ color: color }} />;
            } else if (schema.key?.startsWith('dir-')) {
                schema.icon = <FolderOutlined style={{ color: '#faad14' }} />;
                const { syntax, projectName } = schema.value;
                const key = `${syntax}/${projectName}`;
                let dirs = this.schemaDirs[key];
                if (dirs === undefined) {
                    dirs = [];
                    this.schemaDirs[key] = dirs;
                }
                dirs.push(schema.value);
            } else {
                schema.icon = <TableOutlined style={{ color: '#389e0d' }} />;
            }
            if (schema.children != null) {
                schema.children = schema.children.map(col => {
                    if (col.key?.startsWith('file-')) {
                        let color = '#1890ff';
                        if (col?.value?.syntax === 'HOLO-SQL') {
                            color = '#faad14';
                        }
                        col.icon = <FileTextOutlined style={{ color: color }} />;
                    } else if (schema.value) { // TODO:
                        col.value.origin = schema.value.origin;
                        col.value.projectName = schema.value.projectName;
                    }
                    return col;
                })
            }

            return schema;
        });
        //console.log(this.schemaDirs);
        return level;
    }

    buildExtendedKeys(schemasTree) {
        if (!schemasTree) {
            return [];
        }
        const keys = schemasTree.map(node => node.key);
        return keys;
    }

    buildSchemasKeywords(schemasTree) {
        if (!schemasTree) {
            return
        }
        const schemaKeywords = {};

        schemasTree.forEach(origin => {
            // if (origin.key === "origin-MaxCompute") {
            //     origin.children.forEach(project => {
            //         project.children.forEach(level => this._buildLevelKeywords(level, schemaKeywords))
            //         return project
            //     });
            // } else if (origin.key === "origin-Hologres") {
            //     origin.children.forEach(level => this._buildLevelKeywords(level, schemaKeywords))
            // }
            origin.children.forEach(project => {
                project.children.forEach(level => this._buildLevelKeywords(level, schemaKeywords))
                return project
            });
        })

        // for (let level of schemasTree) {
        //     if (!level.title.endsWith('层')) {
        //         continue;
        //     }
        //     for (let schema of level.children) {
        //         schemaKeywords[schema.title] = {
        //             columns: schema.children.map(field => field.value),
        //             comment: schema.value.comment
        //         };
        //     }
        // }
        return schemaKeywords;
    }

    _buildLevelKeywords(level, schemaKeywords) {
        if (level.key.endsWith("saved-files")) {
            return;
        }
        for (let schema of level.children) {
            schemaKeywords[schema.title] = {
                columns: schema.children.map(field => field.value),
                comment: schema?.value?.comment
            };
        }
    }

    fetchOwnedProjects() {
        UIFetchService.get('/api/v1/querying_works/owned/projects')
            .then(result => this.setState({ projects: result }))
    }

    fetchOwnedSchemasTree(key, force) {
        window.CyaLogger?.sendClick(null, 'refresh_owned_schemas_tree', { "value": {} });

        if (isNotEmpty(key)) {
            force = true;
        }

        this.setState({ schemaKey: key });

        this.readCache().then(json => {
            if (isNotEmpty(json) && !force) {
                const cache = JSON.parse(json);
                this.processSchemasTree(key, cache.schemasTree);
            } else {
                UIFetchService.get(`/api/v1/querying_works/owned/schemas/tree?key=${key}`)
                    .then(schemasTree => {
                        if (isEmpty(key)) {
                            const json = JSON.stringify({ expries: moment().add(1, 'days').format(dateTimeFormat), schemasTree });
                            this.writeCache(json);
                        }
                        this.processSchemasTree(key, schemasTree);
                    });
            }
        });
    }

    async requestFs() {
        // if (!window.webkitRequestFileSystem) {
        //     return new Promise(resolve => resolve());
        // }
        // return new Promise(resolve => window.webkitRequestFileSystem(window.TEMPORARY, 20000000, resolve));
        return new Promise(resolve => resolve());
    }

    async requestCacheFile(options) {
        return new Promise(resolve => {
            if (!this.fs) {
                return resolve();
            }
            this.fs.root.getFile(`${QueryingWorksView.schemasCacheKey}.json`, options, resolve);
        });
    }

    async invalidateCache() {
        const file = await this.requestCacheFile({});

        return new Promise(resolve => {
            if (file === undefined) {
                return resolve('file not open yet');
            }
            if (file.remove === undefined) {
                return resolve('remove not exists');
            }
            file.remove(resolve, e => console.log(e));
        });
    }

    async writeCache(json) {
        await this.invalidateCache();
        const wr = await this.requestCacheWriter();
        if (!wr) {
            return new Promise(resolve => resolve());
        }
        return wr.write(new Blob([json], { type: 'application/json' }));
    }

    async requestCacheWriter() {
        const file = await this.requestCacheFile({ create: true });

        return new Promise(resolve => {
            if (file === undefined) {
                return resolve();
            }
            if (file.createWriter === undefined) {
                return resolve();
            }
            file.createWriter(resolve, e => {
                console.log(e);
                resolve();
            });
        });
    }

    async readCache() {
        const entry = await this.requestCacheFile({ create: true });

        return new Promise(resolve => {
            if (!entry) {
                return resolve();
            }
            entry.file(file => {
                let reader = new FileReader();
                reader.onload = () => {
                    // const len = localStorage.getItem(QueryingWorksView.schemasCacheKey);
                    // if (len > 0) {
                    //     resolve(reader.result.substring(0, len));
                    // } else {
                    //     resolve();
                    // }
                    resolve(reader.result);
                };
                reader.onerror = () => {
                    resolve();
                    console.log(reader.error);
                };
                reader.readAsText(file);
            }, e => {
                resolve();
                console.log(e);
            });
        });
    }

    processSchemasTree(key, schemasTree) {
        isEmpty(key) ? this.setState({
            schemasTree: this.buildSchemasTree(schemasTree),
            schemaKeywords: this.buildSchemasKeywords(schemasTree),
            extendedKeys: this.buildExtendedKeys(schemasTree)
        }) : this.setState({
            schemasTree: this.buildSchemasTree(schemasTree),
            extendedKeys: this.buildExtendedKeys(schemasTree)
        });
    }

    fetchOwnedDevScriptsTree(key) {
        window.CyaLogger?.sendClick(null, 'refresh_owned_dev_scripts_tree', { "value": {} });

        this.setState({ devScriptKey: key });
        UIFetchService.get(`/api/v1/querying_works/owned/dev/tree?key=${key}`)
            .then(schemasTree => {
                //console.log(schemasTree);
                isEmpty(key) ? this.setState({
                    devScriptsTree: this.buildDevScriptsTree(schemasTree),
                    // devScriptsKeywords: this.buildDevScriptsTree(schemasTree),
                    // extendedKeys: this.buildExtendedKeys(schemasTree)
                }) : this.setState({
                    devScriptsTree: this.buildDevScriptsTree(schemasTree),
                    // extendedKeys: this.buildExtendedKeys(schemasTree)
                });
            });
    }

    getContent() {
        const renage = this.monacoInstance?.getSelection();
        const text = this.monacoInstance?.getModel().getValueInRange(renage);
        if (text === '' || typeof text !== 'string') {
            return this.monacoInstance?.getValue();
        } else {
            return text;
        }
    }

    isSelectedInEditor() {
        const renage = this.monacoInstance?.getSelection();
        const text = this.monacoInstance?.getModel().getValueInRange(renage);
        return isNotEmpty(text);
    }

    isNotSelectedInEditor() { return !this.isSelectedInEditor(); }

    async commitSqlTask(scriptId, force) {
        window.CyaLogger?.sendClick(null, 'commit_sql_task', { value: { sql: this.getContent() } });

        const file = this.getCurrentFile();
        //console.log(file);
        const request = {
            sql: Base64.encode(this.getContent()),
            syntax: file?.syntax,
            projectName: this.state.activeProject
        };
        this.setState({ task: { state: 'PENDING' }, preTaskError: 'OK', tabsActiveKey: 'logs', resultPageNo: 1 });
        let result;
        let query = '';
        try {
            if (scriptId > 0) {
                query = `?scriptId=${scriptId}`;
            }
            if (force) {
                if (scriptId > 0) {
                    query = `${query}&force=true`;
                } else {
                    query = `?force=true`;
                }
            }
            result = await UIFetchService.post(`/api/v1/querying_works/tasks/commit${query}`, request);
        } catch (e) {
            this.setState({ task: { state: 'FAIL' }, preTaskError: e.toString() });
            return;
        }
        // 通过语法校验之后重新获取脚本列表
        this.fetchOwnedDevScriptsTree("");

        if (typeof result?.taskId !== 'number') {
            if (!(scriptId > 0) && (result?.message?.startsWith('cost:lo:') || result?.message?.startsWith('cost:hi:'))) {
                const tooHi = result.message.startsWith('cost:hi:');
                const cost = result.message.substring(8);
                const onOk = () => { if (!tooHi) { this.commitSqlTask(scriptId, true) } };
                Modal.confirm({
                    title: '成本提醒',
                    icon: <ExclamationCircleOutlined />,
                    content: <>
                        <Row justify='center'>
                            <Col>
                                本次查询费用：{Number.parseFloat(cost).toFixed(4)}元
                            </Col>
                        </Row>
                        <Row justify='center'>
                            {tooHi ? <Col>
                                本次查询成本过高，查询无法进行，建议优化SQL或联系数据中台。
                            </Col> : <Col>
                                本次查询成本偏高，建议优化SQL或联系数据中台。
                            </Col>}
                        </Row>
                    </>,
                    okType: tooHi ? 'ghost' : 'primary',
                    okText: tooHi ? undefined : '继续执行',
                    onOk: tooHi ? undefined : onOk,
                    onCancel() { },
                });
            }

            this.setState(({ task }) => {
                task.state = 'FAIL';
                return { task, preTaskError: result?.message };
            });
            return;
        }

        this.setState(({ task }) => {
            task.id = result.taskId;
            return { task, preTaskError: result.message }
        });

        this.beginPollTask(result.taskId, scriptId, file.id, this.getContent());
    }

    async estimateSqlCost() {
        window.CyaLogger?.sendClick(null, 'estimate_sql_cost', { value: {} });

        if (this.state.activeDataOrigin !== "MaxCompute") {
            message.error("成本计算仅支持数据源为 MaxCompute 的查询")
            return
        }

        const request = {
            sql: this.getContent(),
            projectName: this.state.activeProject
        };
        this.setState({ estimateSqlCostPending: true, estimateSqlCostVisible: true, taskCost: [] });
        const taskCost = await UIFetchService.post('/api/v1/querying_works/tasks/cost', request);
        this.setState({ estimateSqlCostPending: false, taskCost });
    }

    async interruptTask() {
        window.CyaLogger?.sendClick(null, 'interrupt_task', { value: { taskId: this.state.task.id } });

        if (this.state.task.id > 0) {
            await UIFetchService.method('PUT', `/api/v1/querying_works/owned/tasks/${this.state.task.id}/interrupt`, {});
        }
    }

    beginPollTask(taskId, scriptId, fileId, sql) {
        this.taskPollingTimer = setInterval(async () => {
            const task = await UIFetchService.get(`/api/v1/querying_works/owned/tasks/${taskId}`);
            for (let job of task.jobs) {
                if (job.state === 'OK' && this.state.results[job.id] === undefined) {
                    if (scriptId > 0) {
                        // nothing
                    } else {
                        const columns = this.getJobResultColumns(job.logs);
                        const resultCount = this.getJobResultCount(job.logs);
                        this.fetchResultRows(fileId, sql, job.id, columns, resultCount, 1, 2000);
                    }
                }
            }
            if (task.state === 'OK' || task.state === 'FAIL') {
                clearInterval(this.taskPollingTimer);
                if (task.state === 'OK') {
                    if (scriptId === undefined) {
                        if (!this.state.tabsActiveKey.startsWith('result-')) {
                            this.setState({ tabsActiveKey: `result-${task.jobs[0].id}` });
                        }
                    }
                } else {
                    message.error(`执行失败！${task.logs}`);
                }
                this.fetchJobsHistory(this.state.historyPageNo, this.state.historyPageSize);
                // 监听回调之后
                this.fetchOwnedDevScriptsTree("");
            }
            this.setState({ task });
        }, 1000);
    }

    isTaskPending() {
        return typeof this.state.task.state === 'string' && this.state.task.state !== 'OK' && this.state.task.state !== 'FAIL';
    }

    getJobResultColumns(logs) {
        if (!logs instanceof Array) {
            return [];
        }
        const log = logs.find((log) => log.stage === 'RESULT');
        return JSON.parse(log.logs);
    }

    getJobResultCount(logs) {
        if (!logs instanceof Array) {
            return 0;
        }
        const log = logs.find((log) => log.stage === 'RESULT');
        return Number.parseInt(log.params);
    }

    async fetchResultRows(fileId, sql, jobId, columns, resultCount, pageNo, pageSize, dontFocusRows) {
        const result = await UIFetchService.get(`/api/v1/querying_works/owned/jobs/${jobId}/result?pageNo=${pageNo}&pageSize=${pageSize}`);
        const rows = result.map(row => {
            for (let column of columns.names) {
                if (row[column] === undefined) {
                    row[column] = 'NULL';
                }
            }
            return row;
        });
        const results = this.state.results;
        const oldOne = results[jobId];
        results[jobId] = {
            index: oldOne === undefined ? this.spawnIndex++ : oldOne.index,
            fileId,
            sql,
            jobId,
            rows,
            columns,
            total: resultCount,
            pageNo,
            pageSize
        };
        //this.setState({ results, tabsActiveKey: (dontFocusRows ? 'logs' : `result-${jobId}`) });
        this.setState({ results });
    }

    async fetchJobsHistory(pageNo, pageSize, key = null) {
        const journal = await UIFetchService.get(`/api/v1/querying_works/owned/jobs/journal?pageNo=${pageNo}&pageSize=${pageSize}${key === null ? '' : '&keyword=' + encodeURI(key)}`);
        this.setState({ history: journal.items, historyTotal: journal.total, historyPageNo: pageNo, historyPageSize: pageSize });
    }

    onCopyResult(activeKey) {
        //this.find
        const jobId = Number.parseInt(activeKey.split('-')[1]);
        const rs = this.state.results[jobId]
        //console.log(rs);
        //this.state.results
        const header = rs.columns.names.join('\t') + '\n';
        const content = rs.rows.map(row => {
            return rs.columns.names.map(key => {
                const val = row[key];
                return val === undefined ? 'NULL' : val.toString();
            }).join('\t');
        }).join('\n');

        copy(header + content, { format: 'text/plain' });
        message.success('复制成功');
    }

    onExportResult(activeKey) {
        //this.find
        const jobId = Number.parseInt(activeKey.split('-')[1]);
        // /api/v1/querying_works/owned/jobs/
        this.setState(({ results }) => {
            results[jobId].exporting = true;
            return { results };
        });

        message.success('数据导出任务已创建，请在企业微信查收...')
        UIFetchService.post(`/api/v1/querying_works/owned/jobs/${jobId}/export`).then(() =>
            this.setState(({ results }) => {
                results[jobId].exporting = false;
                return { results };
            })
        );
    }

    stillExporting(activeKey) {
        const jobId = Number.parseInt(activeKey.split('-')[1]);
        const rs = this.state.results[jobId];
        if (rs === undefined || rs === null) {
            return false;
        }
        return rs.exporting;
    }

    saveTags(files) {
        const tags = files.map(file => {
            if (file.id > 0) {
                return { id: file.id };
            } else {
                const editor = this.editors[file.domId];
                return { id: file.id, fileName: file.fileName, content: editor?.instance?.getValue(), origin: file.origin, projectName: file.projectName };
            }
        });
        localStorage.setItem('sql.currentTags', JSON.stringify(tags));
    }

    provideHover = (model, position) => {
        if (isEmpty(this.monacoInstance?.getValue())) {
            return [];
        }

        const prefixPartialText = model.getValueInRange({
            startLineNumber: position.lineNumber,
            startColumn: 1,
            endLineNumber: position.lineNumber,
            endColumn: position.column
        });

        function isTremChar(s) {
            return ODPSLexer.termChars.has(s);
        }
        let maybeSymbol = '';
        let renge = {
            startLineNumber: position.lineNumber,
            startColumn: 1,
            endLineNumber: position.lineNumber,
            endColumn: position.column
        };
        for (let i = prefixPartialText.length - 1; i--; i >= 0) {
            if (isTremChar(prefixPartialText[i])) {
                maybeSymbol = prefixPartialText.substring(i + 1);
                renge.startColumn = i + 1;
                break;
            }
            if (i < 0) {
                break;
            }
        }
        if (maybeSymbol === '') {
            maybeSymbol = prefixPartialText;
        }

        const postfixPartialText = model.getValueInRange({
            startLineNumber: position.lineNumber,
            startColumn: position.column,
            endLineNumber: position.lineNumber,
            endColumn: model.getLineMaxColumn(position.lineNumber)
        });
        let hit = false;
        for (let i = 0; i < postfixPartialText.length; i++) {
            if (isTremChar(postfixPartialText[i])) {
                maybeSymbol = `${maybeSymbol}${postfixPartialText.substring(0, i)}`;
                hit = true;
                break;
            }
        }
        if (!hit) {
            maybeSymbol = `${maybeSymbol}${postfixPartialText}`;
        }

        //console.log(`Hover key: ${maybeSymbol}`);
        const file = this.getCurrentFile();
        if (maybeSymbol in this.state.schemaKeywords) {
            //console.log(this.state.schemaKeywords[maybeSymbol]);
            const schema = this.state.schemaKeywords[maybeSymbol];
            // /data_map/schema_desc/detail/bcz_datap/dm_finance_sales_sub_item
            const contents = [{ value: `[查看详细信息](${window.location.origin}/data_map/schema_desc/detail/${file?.projectName}/${maybeSymbol})` }];
            if (schema.comment) {
                contents.push({
                    value: `*${schema.comment}*`
                });
            }
            for (let field of schema.columns) {
                contents.push({
                    value: `*${field.name}*: \`${field.type}\` ${field.comment === null ? '' : '-- ' + field.comment}`
                });
            }

            return { contents, renge }
        }

        return [];
    }

    provideCompletionItems = (model, position) => {
        if (isEmpty(this.monacoInstance?.getValue())) {
            return {};
        }

        const textUntilPosition = model.getValueInRange({
            startLineNumber: position.lineNumber,
            startColumn: 1,
            endLineNumber: position.lineNumber,
            endColumn: position.column
        });
        //console.log(textUntilPosition);
        let raw = textUntilPosition.match(/(\S+)$/)[0];
        if (!raw) { return [] }
        if (raw.indexOf(',') >= 0) {
            const parts = raw.split(',');
            raw = parts[parts.length - 1];
        }
        const match = raw.toUpperCase();

        var suggestions = [];
        const analyzer = new ODPSAnalyzer(this.monacoInstance.getValue(), this.state.schemaKeywords);
        try {
            analyzer.analyze();
            const hint = analyzer.contains(position);
            console.log(analyzer.results, position);
            let columns, keyword;
            if (raw.endsWith('.')) {
                columns = hint?.schemas[raw.split('.')[0]]?.columns;
                keyword = raw.split('.')[1];
            } else {
                columns = hint?.columns;
                keyword = raw;
            }
            if (hint) {
                columns?.forEach(column => {
                    if (column.name.indexOf(keyword) === 0) {
                        const comment = (column?.comment === null || column?.comment === undefined || column?.comment === '') ? '<缺少注释>' : column.comment;
                        suggestions.push({
                            label: `${column.name} ${comment}`,
                            kind: monaco.languages.CompletionItemKind.Field,
                            insertText: column.name
                        });
                    }
                });
            }
        } catch (e) {
            console.log(e);
        }

        ODPSParser.odpsKeywords.forEach(keyword => {
            if (keyword.indexOf(match) === 0) {
                suggestions.push({
                    label: keyword,
                    kind: monaco.languages.CompletionItemKind.Keyword,
                    insertText: keyword + ' '
                });
            }
        });

        ODPSParser.odpsFunctions.forEach(keyword => {
            if (keyword.indexOf(match) === 0) {
                suggestions.push({
                    label: keyword,
                    kind: monaco.languages.CompletionItemKind.Function,
                    insertText: keyword
                });
            }
        });

        Object.keys(this.state.schemaKeywords).forEach(keyword => {
            if (keyword.toUpperCase().indexOf(match) !== -1) {
                suggestions.push({
                    label: `${keyword} ${this.state.schemaKeywords[keyword]?.comment}`,
                    kind: monaco.languages.CompletionItemKind.Variable,
                    insertText: keyword
                });
            }
        });

        return { suggestions };
    }

    doSyntaxChecking(editor) {
        const model = editor.getModel();
        try {
            const parser = new ODPSParser(model.getValue());
            parser.parseBlock();
            const markers = parser.errors.map(e => {
                const length = e.token?.value?.length;
                return {
                    startLineNumber: e.line,
                    startColumn: e.column,
                    endLineNumber: e.line,
                    endColumn: e.column + length !== undefined ? length : 1,
                    message: e.message
                }
            })
            monaco.editor.setModelMarkers(model, '错误:', markers);
        } catch (e) {
            console.log(e);
            const length = e.token?.value?.length;

            monaco.editor.setModelMarkers(model, '错误:', [{
                startLineNumber: e.line,
                startColumn: e.column,
                endLineNumber: e.line,
                endColumn: e.column + length !== undefined ? length : 1,
                message: e.message
            }]);
        }
    }
}

class TableSchemaModal extends React.Component {

    constructor() {
        super();
        this.state = {
            columns: [
                {
                    name: 'aaaa',
                    type: 'BIGINT',
                    size: '',
                    comment: '测试测试'
                }, {
                    name: 'bbbb',
                    type: 'STRING',
                    size: '',
                    comment: '测试测试'
                }
            ]
        };
    }

    componentDidMount() {

    }

    render() {
        return <Modal
            title="创建表"
            visible={this.props.visible}
            onCancel={this.props.onCancel}
            onOk={this.props.onCommit}
            okText="提交"
            width={700}
        >
            <Space direction="vertical" style={{ width: '100%' }}>
                <Row>
                    <Col flex="15%" style={{ alignSelf: 'center' }}>
                        <span>表名：</span>
                    </Col>
                    <Col flex="60%">
                        <Input
                            addonBefore="tmp_"
                            value={this.state.name}
                            onChange={({ target: { value } }) => this.setState({ name: value })}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col flex="15%" style={{ alignSelf: 'center' }}>
                        <span>注释：</span>
                    </Col>
                    <Col flex="60%">
                        <Input onChange={({ target: { value } }) => this.setState({ comment: value })} />
                    </Col>
                </Row>
            </Space>
            <Divider />
            <Row style={{ margin: '0 0 10px 0' }}>
                <Col flex="30%"><span>名称</span></Col>
                <Col flex="18%"><span>类型</span></Col>
                <Col flex="25%"><span>大小</span></Col>
                <Col flex="10%"><span>注释</span></Col>
            </Row>
            {this.state.columns.map((column, index) => <Row>
                <Col style={{ margin: '0 10px 10px 0' }}>
                    <Input
                        size="small"
                        value={column.name}
                        onChange={({ target: { value } }) => this.setState(({ columns }) => {
                            columns[index].name = value;
                            return { columns };
                        })}
                    />
                </Col>
                <Col style={{ margin: '0 10px 10px 0' }}>
                    <Select
                        size="small"
                        style={{ width: 100 }}
                        value={column.type}
                        onChange={value => this.setState(({ columns }) => {
                            columns[index].type = value;
                            return { columns };
                        })}
                    >
                        <Select.Option value="BIGINT">BIGINT</Select.Option>
                        <Select.Option value="INT">INT</Select.Option>
                        <Select.Option value="STRING">STRING</Select.Option>
                        <Select.Option value="VARCHAR">VARCHAR</Select.Option>
                        <Select.Option value="DATETIME">DATETIME</Select.Option>
                        <Select.Option value="TIMESTAMP">TIMESTAMP</Select.Option>
                    </Select>
                </Col>
                <Col style={{ margin: '0 10px 10px 0', width: 80 }}>
                    <Input
                        size="small"
                        value={column.size}
                        onChange={({ target: { value } }) => this.setState(({ columns }) => {
                            columns[index].size = value;
                            return { columns };
                        })}
                    />
                </Col>
                <Col style={{ margin: '0 10px 10px 0', width: 240 }}>
                    <Input
                        size="small"
                        value={column.comment}
                        onChange={({ target: { value } }) => this.setState(({ columns }) => {
                            columns[index].comment = value;
                            return { columns };
                        })}
                    />
                </Col>
                <Col>
                    <Button
                        type="default"
                        shape="circle"
                        size="small"
                        icon={<MinusOutlined />}
                        onClick={() => this.setState(({ columns }) => {
                            columns = columns.filter((_, idx) => idx !== index);
                            return { columns };
                        })}
                    />
                </Col>
            </Row>)}
            <Row>
                <Col flex="auto"></Col>
                <Col>
                    <Button
                        onClick={() => this.setState(({ columns }) => {
                            columns.push({
                                name: '',
                                type: '',
                                size: '',
                                comment: ''
                            })
                            return { columns };
                        })}
                    >增加字段</Button>
                </Col>
            </Row>
        </Modal>
    }
}

class ConfirmFileNameModal extends React.Component {

    componentDidMount() {
        this.input?.focus();
        this.input?.select();
    }

    render() {
        return <Modal
            title={isNotEmpty(this.props.title) ? this.props.title : "请输入文件名"}
            visible={this.props.visible}
            onOk={this.props.onOk}
            onCancel={this.props.onCancel}
        >
            <Row>
                <Col span={24}>
                    <Input
                        id="confirm-file-name"
                        addonBefore={<FileTextOutlined />}
                        placeholder="文件名不能重复"
                        ref={(self) => this.input = self}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        onPressEnter={this.props.onOk}
                    ></Input>
                </Col>
            </Row>
            {isNotEmpty(this.props.error) && <>
                <div style={{ height: 10 }}></div>
                <Row>
                    <Col span={12}>
                        <span style={{ color: 'red' }}>{this.props.error}</span>
                    </Col>
                </Row>
            </>}
        </Modal>;
    }
}

class ConfirmInputModal extends React.Component {

    constructor() {
        super();
        this.state = {
            value: '',
        }
    }

    componentDidMount() {
        this.input?.focus();
        this.input?.select();

        this.setState({ value: this.props.value });
    }

    render() {
        return <Modal
            title={this.props.title}
            visible={this.props.visible}
            onOk={() => this.props.onOk(this.state.value)}
            onCancel={this.props.onCancel}
        >
            <Row>
                <Col span={24}>
                    <Input
                        id="confirm-dir-name"
                        addonBefore={<FileTextOutlined />}
                        ref={(self) => this.input = self}
                        value={this.state.value}
                        onChange={({ target: { value } }) => this.setState({ value })}
                        onPressEnter={() => this.props.onOk(this.state.value)}
                    ></Input>
                </Col>
            </Row>
            {isNotEmpty(this.props.error) && <>
                <div style={{ height: 10 }}></div>
                <Row>
                    <Col span={12}>
                        <span style={{ color: 'red' }}>{this.props.error}</span>
                    </Col>
                </Row>
            </>}
        </Modal>;
    }
}


class GenerateDDLModal extends React.Component {

    constructor() {
        super();
    }

    componentDidMount() {
        const domNode = document.getElementById('side-template-editor');
        monaco.editor.create(domNode, {
            value: this.props.ddl,
            theme: 'vs-light',
            fontSize: 13,
            language: 'sql',
            minimap: { enabled: false },
            automaticLayout: false
        });
    }

    render() {
        return <Modal
        {...this.props}
        title="建表语句"
        footer={<>
            <Button onClick={this.copyToClipBoard.bind(this)
            }>复制</Button>
        </>}
        width={570}
        >
        <Row>
            <Col flex='auto' style={{ margin: '0 7px 0 7px' }}>
                    <div id="side-template-editor"
                        style={{
                            textAlign: 'left',
                            border: '1px solid #d9d9d9',
                            height: '500px',
                            width:'500px'
                        }}></div>
             </Col>
        </Row>
  
        </Modal>;
    }


    copyToClipBoard() {
        let textArea = document.createElement("textarea");
        textArea.value = this.props.ddl;
        textArea.style.position = "absolute";
        textArea.style.opacity = 0;
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise(() => {
            document.execCommand('copy') ?  message.success("复制成功") :  message.error("复制失败");
            textArea.remove();
            this.props.onCancel();
        });
    }
 
}

function Skeleton(props) {
    //console.log(props);
    return <div
        style={{
            height: props.height,
            width: '100%',
            color: 'gray',
            backgroundColor: '#fafafa',
            overflowY: 'auto'
        }}>
        <Row justify='center' style={{ margin: '20px 0 0 0' }}>
            <Col flex='200px'>
                <span>
                    <Button size='small' icon={<SaveOutlined />} /> 保存当前代码
                </span>
            </Col>
            <Col flex='200px'>
                <span>
                    <Button size='small' icon={<DollarOutlined style={{ color: "#faad14" }} />} /> 估计运行费用
                </span>
            </Col>
            <Col flex='200px'>
                <span>
                    <Button size='small' icon={<CaretRightOutlined />} /> 运行代码
                </span>
            </Col>
        </Row>
        <Row justify='center' style={{ margin: '7px 0 0 0' }}>
            <Col flex='200px'>
                <span>
                    <Button size='small' icon={<BugOutlined />} /> 开发任务中调试代码
                </span>
            </Col>
            <Col flex='200px'>
                <span>
                    <Button size='small' icon={<PauseOutlined />} /> 取消运行任务
                </span>
            </Col>
            <Col flex='200px'>
                <span>
                    <Button size='small' icon={<DeleteOutlined />} /> 删除代码
                </span>
            </Col>
        </Row>
        <Row justify='center' style={{ margin: '20px 0 0 0' }}>
            <Col>
                <span>点击</span>
                <Button size='small' icon={<PlusOutlined />} />
                <span>按钮可以新建<code style={{ color: 'green' }}>查询任务</code>或者<code style={{ color: 'blue' }}>开发任务</code></span>
            </Col>
        </Row>
        <Row justify='center' style={{ margin: '7px 0 0 0' }}>
            <Col flex='100px' style={{ textAlign: 'right', margin: '0 7px 0 0' }}>
                <code style={{ color: 'green' }}>查询任务</code>
            </Col>
            <Col flex='550px'>
                <span>仅仅支持SELECT语句的查询，代码文件可以保存</span>
            </Col>
        </Row>
        <Row justify='center' style={{ margin: '7px 0 0 0' }}>
            <Col flex='100px' style={{ textAlign: 'right', margin: '0 7px 0 0' }}>
                <code style={{ color: 'blue' }}>开发任务</code>
            </Col>
            <Col flex='550px'>
                <span>SELECT语句的结果可以保存一个表中，支持以外部表的形式引入HOLO中</span>
            </Col>
        </Row>
        <Row justify='center' style={{ margin: '7px 0 0 0' }}>
            <Col flex='100px' style={{ textAlign: 'right', margin: '0 7px 0 0' }}>
                <MaxComputeIcon />
            </Col>
            <Col flex='550px'>
                <span>对应的是MaxCompute(OPDS-SQL)语法，可以选择MaxCompute中的不同项目空间</span>
            </Col>
        </Row>
        <Row justify='center' style={{ margin: '7px 0 0 0' }}>
            <Col flex='100px' style={{ textAlign: 'right', margin: '0 7px 0 0' }}>
                <HologresIcon />
            </Col>
            <Col flex='550px'>
                <span>对应的是Hologres(Postgre-SQL)语法，可以选择Hologres中的不同项目空间</span>
            </Col>
        </Row>
        <Row justify='center' style={{ margin: '7px 0 0 0' }}>
            <Col flex='100px' style={{ textAlign: 'right', margin: '0 7px 0 0' }}>
                <SettingOutlined style={{ color: '#52c41a' }} />
            </Col>
            <Col flex='550px'>
                <span>对应的是开发任务，使用MaxCompute语法</span>
            </Col>
        </Row>
    </div>
}

class MonacoEditorView extends React.Component {

    // attach={(domId)=>}
    componentDidMount() {
        this.monacoInstance = this.props.attach(this.props.domId);
        this.props.done(this.monacoInstance);
    }

    render() {
        return <div id={this.props.domId}>
        </div>
    }
}

class LogsView extends React.Component {

    render() {
        return <div style={{
            width: '100%',
            height: this.props.height,
            overflowX: 'auto',
            overflowY: 'auto'
        }}>
            {this.props.preTaskError !== 'OK' && <>
                <p key='0' style={{ color: '#f5222d', margin: '0px 0px 0px 0px' }}><CloseOutlined /> 无法提交任务 ❗️{this.props.preTaskError}</p>
            </>}
            {this.props.dataSource?.map((job, index) => <>
                <p key={`${job.id}+${index}`} style={{ margin: '0px 0px 0px 0px' }}>---------查询[{index}]---------</p>
                {job.logs.map(log => {
                    let content = '';
                    switch (log.stage) {
                        case 'CHECK': content = '语法检查通过'; break;
                        case 'COMMIT': content = '提交任务'; break;
                        case 'LOG_VIEW': content = <span>任务提交成功：<a href={log.params} rel="noreferrer" target="_blank">查看详情请点此处</a></span>; break;
                        case 'RESULT': content = `获取结果：${log.params}行`; break;
                        case 'DONE':
                            if (log.ok) {
                                content = '执行结束';
                            } else {
                                content = <span style={{ color: '#f5222d' }}>{log.params}</span>
                            }
                            break;
                        default: content = ''; break;
                    }
                    return <p key={`${job.id}+${index}+${log.stage}`} style={{ color: log.ok ? 'black' : '#f5222d', margin: '0px 0px 0px 0px' }}>
                        {log.ok ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseOutlined />} [{log.createdAt}] {content}
                    </p>
                })}
                {this.isJobRunning(job) && <p style={{ color: '#108ee9' }}><LoadingOutlined /> 执行中...</p>}
                {(this.props.isTaskPending && job.state === 'WAITING') && <p style={{ color: '#0f0f0f' }}><LoadingOutlined /> 等待中...</p>}
            </>)}
        </div>
    }

    isJobRunning(job) {
        return job.state !== 'OK' && job.state !== 'FAIL' && job.state !== 'WAITING';
    }
}

// class HistoryView extends React.Component {

//     render() {
//         return <>
//             <Row>
//                 <Table
//                     size="small"
//                     style={{
//                         width: '100%',
//                         height: this.props.height,
//                         overflowX: 'auto',
//                         overflowY: 'auto'
//                     }}
//                     rowClassName="site-data-grid-row"
//                     dataSource={this.props.dataSource}
//                     pagination={false}
//                     onRow={record => {
//                         return {
//                             onDoubleClick: _ => {
//                                 this.props.onRollback(record.committedSql);
//                             }
//                         };
//                     }}
//                     rowKey={record => record.id}
//                 >
//                     <Table.Column
//                         title="结果"
//                         key="id"
//                         dataIndex="state"
//                         width={50}
//                         render={
//                             state => {
//                                 switch (state) {
//                                     case 'WAITING':
//                                         return <PauseCircleOutlined />;
//                                     case 'PENDING':
//                                         return <LoadingOutlined style={{ color: '#108ee9' }} />;
//                                     case 'OK':
//                                         return <CheckCircleTwoTone twoToneColor="#52c41a" />;
//                                     case 'FAIL':
//                                         return <CloseOutlined style={{ color: '#f5222d' }} />;
//                                     default:
//                                         break;
//                                 }
//                             }
//                         }
//                     />
//                     <Table.Column
//                         title="时间"
//                         key="id"
//                         dataIndex="createdAt"
//                         width={180}
//                     />
//                     <Table.Column
//                         title="SQL"
//                         key="id"
//                         dataIndex="committedSql"
//                         width={800}
//                         ellipsis
//                         render={
//                             sql => <code style={{ color: '#d4596f' }}>{sql}</code>
//                         }
//                     />
//                 </Table>
//             </Row>
//             <Row>
//                 <Col flex="auto"></Col>
//                 <Col>
//                     <Pagination
//                         size="small"
//                         current={this.props.current}
//                         pageSize={this.props.pageSize}
//                         total={this.props.total}
//                         onChange={(page, pageSize) => this.props.onPageChange(page, pageSize)}
//                     />
//                 </Col>
//             </Row>
//         </>
//     }
// }

class ResultView extends React.Component {

    constructor() {
        super();
        this.state = {
            columnsFmt: []
        }
    }

    render() {
        // rowHeaders
        const rows = [/*this.props.columns.names*/];
        for (let row of this.props.dataSource) {
            rows.push(this.props.columns.names.map(column => {
                if (column in row) {
                    return row[column];
                } else {
                    return 'NULL';
                }
            }));
        }

        return <>
            <HotTable
                height={this.props.height + 30}
                data={rows}
                rowHeaders
                //colHeaders
                colHeaders={this.props.columns.names}
                columns={this.state.columnsFmt}
                language="zh-CN"
                manualColumnResize
                manualRowResize
                columnSorting={true}
                dropdownMenu={{
                    items: {
                        setFormat: {
                            name: '格式',
                            key: 'format',
                            submenu: {
                                items: [
                                    {
                                        key: 'format:1',
                                        name: '原始数据',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = undefined;
                                                return { columnsFmt };
                                            });
                                        }
                                    }, {
                                        key: 'format:2',
                                        name: '整数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = {
                                                    pattern: '0,00',
                                                    culture: 'zh-CN'
                                                }
                                                return { columnsFmt };
                                            });
                                        }
                                    }, {
                                        key: 'format:3',
                                        name: '保留1位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = {
                                                    pattern: '0.0',
                                                    culture: 'zh-CN'
                                                }
                                                return { columnsFmt };
                                            });
                                        }
                                    }, {
                                        key: 'format:4',
                                        name: '保留2位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = {
                                                    pattern: '0.00',
                                                    culture: 'zh-CN'
                                                }
                                                return { columnsFmt };
                                            });
                                        }
                                    }, {
                                        key: 'format:5',
                                        name: '保留3位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = {
                                                    pattern: '0.000',
                                                    culture: 'zh-CN'
                                                }
                                                return { columnsFmt };
                                            });
                                        }
                                    }, {
                                        key: 'format:6',
                                        name: '保留4位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = {
                                                    pattern: '0.0000',
                                                    culture: 'zh-CN'
                                                }
                                                return { columnsFmt };
                                            });
                                        }
                                    }, {
                                        key: 'format:7',
                                        name: '百分比1位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = {
                                                    pattern: '0.0%',
                                                    culture: 'zh-CN'
                                                }
                                                return { columnsFmt };
                                            });
                                        }
                                    }, {
                                        key: 'format:8',
                                        name: '百分比2位小数',
                                        callback: (key, options) => {
                                            const col = options[0].start.col;
                                            this.setState(({ columnsFmt }) => {
                                                columnsFmt[col].numericFormat = {
                                                    pattern: '0.00%',
                                                    culture: 'zh-CN'
                                                }
                                                return { columnsFmt };
                                            });
                                        }
                                    }
                                ]
                            }
                        },
                        hsep5: '---------',
                        filter1: 'filter_by_condition',
                        filter2: 'filter_operators',
                        filter3: 'filter_by_condition2',
                        filter4: 'filter_by_value',
                        filter5: 'filter_action_bar',

                    }
                }}
                filters={true}
                manualColumnMove={true}
                manualColumnFreeze={true}
                //fixedRowsTop={1}
                licenseKey="non-commercial-and-evaluation"
            >
            </HotTable>
            {/* <div style={{ height: 10 }}></div>
            <Row>
                <Col flex="auto"></Col>
                <Col>
                    <Pagination
                        size="small"
                        current={this.props.current}
                        pageSize={this.props.pageSize}
                        total={this.props.total}
                        onChange={(page, pageSize) => this.props.onPageChange(page, pageSize)}
                    />
                </Col>
            </Row> */}
        </>
    }

    titleRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        Handsontable.renderers.TextRenderer.apply(Handsontable.renderers.TextRenderer,
            [instance, td, row, col, prop, value, cellProperties]);
        td.style.fontWeight = 'bold';
        td.style.color = 'black';
        td.style.background = '#F0F0F0';
    }

    componentDidMount() {
        this.setState({
            columnsFmt: this.props.columns.names.map(name => {
                return {
                    type: this.props.columns.types[name],
                    readOnly: false,
                };
            })
        })
    }
}

export default QueryingWorksView;